
export interface Inverter {
  BC: string;
  BN: string;
  BP: string;
  BP1: string;
  BP2: string;
  BT: string;
  created: number;
  EG1: string;
  EG2: string;
  EG3: string;
  EG4: string;
  EG5: string;
  EG6: string;
  ET1: string;
  ET2: string;
  ET3: string;
  ET4: string;
  ET5: string;
  ET6: string;
  FC1: string;
  FR: string;
  FT1: string;
  GwId: string;
  IS_SLAVE: string;
  IS_MASTER: string;
  MASTER: string;
  MC1: string;
  MC2: string;
  MP1: string;
  MP2: string;
  MT1: string;
  MT2: string;
  P1: string;
  P2: string;
  P3: string;
  P4: string;
  P5: string;
  P6: string;
  P7: string;
  P8: string;
  P9: string;
  P_1AB: string;
  P_1AO: string;
  P_AC_HYD: string;
  P_B1: string;
  P_B2: string;
  P_B_AGGR: string;
  P_BATTERY_LOAD: string;
  P_DC_TOT: string;
  P_DC_HYD: string;
  P_EXP: string;
  P_EXT: string;
  P_GRID_BATTERY: string;
  P_GRID_LOAD: string;
  P_LOAD: string;
  P_SUN_BATTERY: string;
  P_SUN_GRID: string;
  P_SUN_LOAD: string;
  PK: string;
  SK: string;
  TB: string;
  TI: string;
  TYPE: string;
  TS: number;
}
export interface InverterV2 {
  created: number;
  GwId: string;
  ALERTS: string;
  ALERTS_ZCS: string;
  ARM: string;
  DSPM: string;
  DSPS: string;
  BP: string;
  BP1: string;
  BP2: string;
  BT: string;
  BT1: string;
  BT2: string;
  BC: string;
  BC1: string;
  BC2: string;
  BN1: string;
  BN2: string;
  EG1: string;
  EG2: string;
  EG3: string;
  EG4: string;
  EG5: string;
  EG6: string;
  ET1: string;
  ET2: string;
  ET3: string;
  ET4: string;
  ET5: string;
  ET6: string;
  FC1: string;
  FC2: string;
  FC3: string;
  FR: string;
  FT1: string;
  FT2: string;
  FT3: string;
  P_1AB: string;
  P_1AO: string;
  P_AC_HYD: string;
  MP1: string;
  MP2: string;
  MP3: string;
  MP4: string;
  MP5: string;
  MP6: string;
  MP7: string;
  MP8: string;
  MP9: string;
  MP10: string;
  MP11: string;
  MP12: string;
  MT1: string;
  MT2: string;
  MT3: string;
  MT4: string;
  MT5: string;
  MT6: string;
  MT7: string;
  MT8: string;
  MT9: string;
  MT10: string;
  MT11: string;
  MT12: string;
  MC1: string;
  MC2: string;
  MC3: string;
  MC4: string;
  MC5: string;
  MC6: string;
  MC7: string;
  MC8: string;
  MC9: string;
  MC10: string;
  MC11: string;
  MC12: string;
  N_MPPT: string;
  N_MAX_MPPT: string;
  N_MAX_STRINGS: string;
  P_B1: string;
  P_B2: string;
  P_B_AGGR: string;
  P_BATTERY_LOAD: string;
  P_DC_TOT: string;
  P_EXP: string;
  P_EXT: string;
  P_LOAD: string;
  P_SELF: string;
  PK: string;
  SK: string;
  SC1: string;
  SC2: string;
  SC3: string;
  SC4: string;
  SC5: string;
  SC6: string;
  SC7: string;
  SC8: string;
  SC9: string;
  SC10: string;
  SC11: string;
  SC12: string;
  SC13: string;
  SC14: string;
  SC15: string;
  SC16: string;
  SC17: string;
  SC18: string;
  SC19: string;
  SC20: string;
  SC21: string;
  SC22: string;
  SC23: string;
  SC24: string;
  ST1: string;
  ST2: string;
  ST3: string;
  ST4: string;
  ST5: string;
  ST6: string;
  ST7: string;
  ST8: string;
  ST9: string;
  ST10: string;
  ST11: string;
  ST12: string;
  TB: string;
  TB1: string;
  TB2: string;
  TI: string;
  TYPE: string;
  SOL_TEMP: number;
  SOL_IRR: number;
  SOL_EG: number;
  TS: number;
  TZ: string;
  V: number;
}
export interface EvChRT {
  ST: number;
  TID: string;
  CT: number;
  EM: number;
  SEM: number;
  CP: number;
  pcv: number;
  SOC: number;
  RT: number;
  SK: string;
  created: number;
  PK: string;
  TS: number;
  ID: number;
  PP: number;
  AE: number;
  GwId: string;
}
export interface EvChRTV2 {
  ST: EvchST;
  TID: string;
  CT: number;
  EM: number;
  SEM: number;
  CP: number;
  pcv: number;
  SOC: number;
  RT: number;
  SK: string;
  created: number;
  PK: string;
  TS: number;
  ID: number;
  PP: EvchPP;
  AE: number;
  GwId: string;
}
export interface AHEvChRT {
  ST: EvchST;
  TID: string;
  CT: number;
  EM: number;
  SEM: number;
  CP: number;
  pcv: number;
  SK: string;
  created: number;
  PK: string;
  TS: number;
  TZ: number;
  evchBatteryProtectEna: boolean;
  evchBatterySOCLimit: number;
  evchPwrImportLimit: boolean;
  evchPwrImportValue: number;
  evchParallelEna: boolean;
  evchStrategy: AHevchStrategyEnum;
  GwId: string;
  deviceType: AHdeviceTypeEnum;
}
export interface EvChCSESSION {
  created: number;
  Charged: number;
  TZ: number;
  Reason: number;
  PK: string;
  SK: string;
  TID: string;
  TS: number;
  Stop: number;
}
export interface CMDLogs {
  logs: CMDLog[];
  nextToken: string;
}
export interface CMDLog {
  deviceId: string;
  timestamp: number;
  transactionId: string;
  transactionIdKey: string;
  clientId: string;
  action: ActionLog;
}
export interface ActionRes {
  msg: string;
  success: boolean;
  msgCode: number;
}
export interface ActionCMD {
  args: string[];
  cmd: string;
}
export interface EvChSESSION {
  created: number;
  CT: number;
  deltaCT: number;
  EM: number;
  EMI: number;
  PK: string;
  PP: number;
  SEM: number;
  SK: string;
  TID: string;
  TS: number;
  TSI: number;
}
export interface EvChDAY {
  created: number;
  PK: string;
  DEM: number;
  EM: number;
  DCT: number;
  SK: string;
  TS: number;
  CC: number;
  TIDA: EvChSESSIONInDay[];
}
export interface EvChSESSIONInDay {
  CT: number;
  SEM: number;
  PP: number;
  TID: string;
  TS: number;
  TSI: number;
}
export interface EvChMONTH {
  created: number;
  EM: number;
  EMI: number;
  MEM: number;
  PK: string;
  SK: string;
  TS: number;
  TSI: number;
}
export interface EvChDAYV2 {
  created: number;
  PK: string;
  DEM: number;
  EM: number;
  DCT: number;
  SK: string;
  TS: number;
  CC: number;
  TIDA: EvChSESSIONInDayV2[];
  GwId: string;
}
export interface EvChSESSIONInDayV2 {
  CT: number;
  SEM: number;
  PP: EvchPP;
  TID: string;
  TS: number;
  TSI: number;
  evchBatteryProtectEna: boolean;
  evchBatterySOCLimit: number;
  evchPwrImportLimit: boolean;
  evchPwrImportValue: number;
  evchParallelEna: boolean;
  evchStrategy: AHevchStrategyEnum;
}
export interface AHEvChDAY {
  created: number;
  PK: string;
  DEM: number;
  EM: number;
  DCT: number;
  SK: string;
  TS: number;
  CC: number;
  TIDA: EvChSESSIONInDayV2[];
  GwId: string;
  deviceType: AHdeviceTypeEnum;
}
export interface AHheatPumpRTData {
  HP_E_EG: number;
  HP_E_ET: number;
  HP_T_EG: number;
  HP_T_ET: number;
  HP_T_PWR: number;
  HP_E_PWR: number;
  DHW_TEMP: number;
  OUT_TEMP: number;
  RET_TEMP: number;
  ENV_TEMP: number;
  CURR_OP_MODE: AHcurrOpModeEnum;
  globStatus: AHglobStatusEnum;
  climOpMode: AHclimOpModeEnum;
  DHWOn: boolean;
  climOnA: boolean;
  DHWSetTemp: number;
  climSetTempHeatingA: number;
  climSetTempCoolingA: number;
  IANA: string;
  SK: string;
  created: number;
  PK: string;
  TS: number;
  TZ: number;
  GwId: string;
}
export interface AHheatPumpDAY {
  PK: string;
  SK: string;
  created: number;
  TS: number;
  HP_E_EG: number;
  HP_E_ET: number;
  HP_T_EG: number;
  HP_T_ET: number;
  RET_TEMP: number;
  DHW_TEMP: number;
  OUT_TEMP: number;
  ENV_TEMP: number;
  CURR_OP_MODE: AHcurrOpModeEnum;
  IANA: string;
  GwId: string;
}
export interface FirmwareData {
  created: number;
  updated: number;
  PK: string;
  SK: string;
  url: string;
  version: string;
  revision: string;
  build: string;
  releaseNotes: string;
}
export interface ConnextData {
  userLevel: number;
  hasOwner: boolean;
  operator: boolean;
  id: string;
  info: ConnextInfo;
  users: ConnextUser[];
  devices: ConnextDevice[];
  io: ConnextIO[];
  config: ConnextConfig;
}
export interface ConnextInfo {
  sn: ConnextSN;
  name: ConnextName;
  fw: ConnextFw;
  hwv: ConnextHwV;
  def: ConnextDef;
  connection: ConnextConnection;
  cell_info: ConnextCellInfo;
}
export interface ConnextSN {
  sn: string;
  timestamp: number;
  uid: string;
  type: string;
  updatedAt: number;
  createdAt: number;
}
export interface ConnextName {
  name: string;
  timestamp: number;
}
export interface ConnextFw {
  fota_status: string;
  timestamp: number;
  type: string;
  fw_ver: string;
  fwCategory: number;
  updatedAt: number;
  createdAt: number;
}
export interface ConnextHwV {
  hwVer: string;
  timestamp: number;
}
export interface ConnextDef {
  thingDef: string;
  type: string;
  timestamp: number;
}
export interface ConnextConnection {
  timestamp: number;
  status: string;
  disconnectReason: string;
  ipAddress: string;
}
export interface ConnextCellInfo {
  imei: string;
  cell_model: string;
  icc_id: string;
  updatedAt: number;
  cell_revision: string;
  cell_serial: string;
}
export interface ConnextUser {
  email: string;
  operator: boolean;
  userLevel: number;
}
export interface EvChType {
  type: string;
  dModel: string;
  model: string;
  sn: string;
  active: number;
  timestamp: number;
  limitPower: number;
  chargerMode: number;
  carConsumption: number;
  fwVer: string;
  startTime: string;
  tStart: number;
  tpDuration: number;
  tpPower: number;
  inputGreenPower: number;
  status: number;
  rsn: number;
  maxpw: number;
  st_cmd: number;
  ready: number;
  wb_err_id: number;
  wb_err_ts: number;
  error_id: number;
  error_ts: number;
  rt_exp: number;
  updatedAt: number;
  createdAt: number;
}
export interface inverterType {
  type: string;
  model: string;
  cmd: string;
  dModel: string;
  sn: string;
  active: number;
  timestamp: number;
  id: number;
  id_list: number;
  modbus_address: number;
  d2evc: number;
  threeF: number;
  version: string;
  thingDef: string;
  sensor_mode: number;
  registered: number;
  rgistered: number;
  k: number;
  dsps: string;
  dspm: string;
  arm: string;
  fw_rev: string;
  grid_meter: number;
}
export interface ConnextIO {
  index: number;
  active: number;
  name: string;
  out1: number;
  var1: number;
  thH: number;
  thL: number;
  time_th: number;
  time_tl: number;
  thH1: number;
  thL1: number;
  time_th1: number;
  time_tl1: number;
  t_min: number;
  d_start: number;
  d_stop: number;
  t0_start: number;
  t1_start: number;
  t2_start: number;
  t3_start: number;
  t4_start: number;
  t5_start: number;
  t6_start: number;
  t0_stop: number;
  t1_stop: number;
  t2_stop: number;
  t3_stop: number;
  t4_stop: number;
  t5_stop: number;
  t6_stop: number;
  n_out: number;
  level: string;
  function: number;
  out_state: number;
  state: number;
  description: string;
  src: string;
  templateId: string;
}
export interface ConnextConfig {
  timestamp: number;
  maxLoadPwr: number;
  plantCurrSensO: number;
  plantCurrSensTR: number;
  invCurrSensO: number;
  invCurrSensTR: number;
  TZ: string;
  latitude: number;
  longitude: number;
  pType: number;
  io_cnt_func: number;
  io_out_used: number;
  io_ing_used: number;
  sensor_mode: number;
  ext_device: number;
  connection: number;
  net: number;
  configVerified: boolean;
  mt_sign: number;
  mt_active: number;
  mt_pb: number;
  tas_en: number;
  tas_pb: number;
  tap_en: number;
  tap_pb: number;
  num_device: number;
  ta_sign: number;
  pext: number;
  error_id: number;
  error_ts: number;
  virtualRTStatus: VirtualRTStateType;
}
export interface VirtualRTStateType {
  active: boolean;
  startTS: number;
  duration: number;
  target: string;
}
export interface Operator {
  timestamp: number;
  email: string;
  active: boolean;
  companyName: string;
  tags: string[];
}
export interface DevicesHistoryPage {
  res: DevicesHistoryType[];
  nextToken: string;
}
export interface DevicesHistoryType {
  timestamp: string;
  data: DeviceHistoryTypeRange;
}
export interface ConnextEvent {
  deviceId: string;
  TS: number;
  eventCode: number;
  msg: string;
  timestamp: number;
}
export interface TopicMessages {
  topicMessages: TopicMessage[];
  nextToken: string;
}
export interface TopicMessage {
  connextId: string;
  topic: string;
  content: string;
  timestamp: number;
}
export interface FirmwareVersionByIdXBluetooth {
  upgradable: boolean;
  operator_channel: number;
  minVersions: FirmwareType;
  latestVersions: FirmwareType;
  upgradeLinks: FirmwareType;
}
export interface FirmwareType {
  ARM: string;
  DSPM: string;
  DSPS: string;
  SAFETY: string;
  SOLARMAN_LOGGER: string;
}
export interface AggregateValuesType {
  ALERTS: string;
  ALERTS_ZCS: string;
  ARM: string;
  DSPM: string;
  DSPS: string;
  created: number;
  BP: string;
  BP_MAX: number;
  BP1: string;
  BP1_MAX: number;
  BP2: string;
  BP2_MAX: number;
  EG1: string;
  EG2: string;
  EG3: string;
  EG4: string;
  EG5: string;
  EG6: string;
  ET1: string;
  ET2: string;
  ET3: string;
  ET4: string;
  ET5: string;
  ET6: string;
  GwId: string;
  P_B1: string;
  P_B2: string;
  P_B_AGGR: string;
  P_DC_TOT: string;
  P_EXP: string;
  P_EXT: string;
  P_LOAD: string;
  P_SELF: string;
  SOL_TEMP: number;
  SOL_IRR: number;
  SOL_EG: number;
  PK: string;
  SK: string;
  TYPE: string;
  TS: number;
  V: number;
}
export interface ModbusCommandLogType {
  deviceId: string;
  timestamp: number;
  user: string;
  request: string;
  response: string;
}
export interface InverterRemoteConfigurationOption {
  deviceId: string;
  email: string;
  optOut: boolean;
  sent: boolean;
  infoRead: boolean;
}
export interface InverterRemoteConfigurationOptionCollection {
  items: InverterRemoteConfigurationOption[];
  nextToken: string;
}
export interface InverterRemotePIDCollection {
  items: InverterRemotePID[];
  nextToken: string;
}
export interface InverterRemotePID {
  deviceId: string;
  dt: string;
}
export interface SimDataQuota {
  volume: number;
  total_volume: number;
  expiry_date: string;
  peak_throughput: number;
  last_volume_added: number;
  last_status_change_date: string;
  threshold_percentage: number;
}
export interface SimUsageStats {
  stats: SimUsage[];
}
export interface SimUsage {
  data: SimUsageData;
  date: string;
  sms: SimUsageSms;
}
export interface SimUsageData {
  cost: string;
  traffic_type: SimUsageTrafficTypeData;
  volume: string;
  volume_rx: string;
  volume_tx: string;
}
export interface SimUsageTrafficTypeData {
  description: string;
  unit: string;
  id: number;
}
export interface SimUsageSms {
  cost: string;
  traffic_type: SimUsageTrafficTypeData;
  volume: string;
  volume_rx: string;
  volume_tx: string;
}
export interface SingleSim {
  iccid: string;
  imsi: string;
  msisdn: string;
  imei: string;
  imei_lock: boolean;
  status: string;
  activation_date: string;
  ip_address: string;
  current_quota: number;
  quota_status: QuotaStatus;
  current_quota_SMS: number;
  quota_status_SMS: QuotaStatus;
}
export interface QuotaStatus {
  id: number;
  description: string;
}
export interface SimStatus {
  status: string;
  location: SimLocation;
  services: string[];
}
export interface SimLocation {
  iccid: string;
  imsi: string;
  last_updated: string;
  operator_id: string;
  operator: SimOperator;
  country: SimCountry;
}
export interface SimOperator {
  id: number;
  name: string;
  country: SimCountry;
}
export interface SimCountry {
  id: number;
  name: string;
  iso_code: string;
  country_id: string;
  country_code: string;
  mcc: string;
  latitude: string;
  longitude: string;
}
export interface PlantIdType {
  plantId: string;
}
export interface RawTelemetriesDocumentCollection {
  results: RawTelemetriesDocument[];
  nextToken: string;
}
export interface RawTelemetriesDocument {
  body: RawTelemetries;
  deviceId: string;
  loggerId: string;
  messageType: string;
  timestamp: number;
}
export interface RawTelemetries {
  FC1: number;
  FC2: number;
  FC3: number;
  BN: number;
  EG3: number;
  ET5: number;
  ET2: number;
  TI: number;
  FR: number;
  P2: number;
  ET1: number;
  P4: number;
  P3: number;
  ET4: number;
  ET6: number;
  MC2: number;
  ET3: number;
  P1: number;
  TS: number;
  MT2: number;
  P6: number;
  P7: number;
  P8: number;
  P9: number;
  FT1: number;
  MP1: number;
  MC1: number;
  EG2: number;
  BP: number;
  BP1: number;
  EG4: number;
  EG6: number;
  EG5: number;
  EG1: number;
  BC: number;
  MP2: number;
  TB: number;
  BT: number;
  P5: number;
  TZ: number;
}
export interface ServicePartner {
  result: string;
  soggetti: Soggetto[];
}
export interface Soggetto {
  codSoggetto: string;
  codDeposito1: string;
  codDeposito2: string;
  installatori: Installatore[];
}
export interface Installatore {
  idCert: number;
  nome: string;
  cognome: string;
  email: string;
  dataFine: string;
}
export interface ServicePartnerInfo {
  email: string;
  codCertificazione: string;
  codSoggetto: string;
  cognome: string;
  nome: string;
}
export interface InterventionProcedure {
  codice: string;
  dati: ProcedureData[];
}
export interface ProcedureData {
  numero: string;
  checksum: string;
  ATTR_WRKFLW: AttrWrkflw[];
  soggetti: SoggettiPratica[];
  extra_manutenzione: ExtraManutenzioneData[];
}
export interface AttrWrkflw {
  codice: string;
  descrizione: string;
  valore: string[];
}
export interface SoggettiPratica {
  tipologia: TipologiaData;
  soggetto: SoggettoData;
  destinatario: DestinatarioData;
}
export interface TipologiaData {
  codice: string;
  descrizione: string;
}
export interface SoggettoData {
  codice: string;
  ragsoc: string;
}
export interface DestinatarioData {
  destcodice: string;
  destrs1: string;
}
export interface ExtraManutenzioneData {
  CODARTMAN: string;
  CODARTSOS: string;
  MATRARTSOS: string;
  MATRART: string;
}
export interface InterventionProcedureForSP {
  numeroPratica: string;
  codiceSoggetto: string;
  checksumPratica: string;
  body: string;
}
export interface SuccessType {
  success: boolean;
}
export interface ConnextDataType {
  loggerId: string;
  info: ConnextInfo;
  devices: inverterType[];
  evch: EvChType[];
  io: ConnextIO[];
  config: ConnextConfig;
}
export interface SolarmanDataType {
  loggerId: string;
  info: SolarmanInfoType;
  devices: SolarmanDeviceType[];
  inverter: SolarmanInverterType[];
  lan: SolarmanLanType;
}
export interface SolarmanInfoType {
  name: SolarmanName;
  fw: SolarmanFw;
  hwv: SolarmanHwV;
  def: SolarmanDef;
  connection: SolarmanConnection;
}
export interface SolarmanName {
  name: string;
  timestamp: number;
}
export interface SolarmanFw {
  cfgFileName: string;
  cfgFileVer: string;
  firmwareVer: string;
  hardwareVer: string;
  manufacturer: string;
  model: string;
  sn: string;
}
export interface SolarmanHwV {
  hwVer: string;
  timestamp: number;
}
export interface SolarmanDef {
  thingDef: string;
  type: string;
  timestamp: number;
}
export interface SolarmanConnection {
  timestamp: number;
  status: string;
  disconnectReason: string;
  ipAddress: string;
}
export interface SolarmanDeviceType {
  sn: string;
  arm: string;
  dspm: string;
  dsps: string;
  created: string;
  lastUpdate: string;
  fota_module: string;
  fota_status: string;
  updating: boolean;
  upd_global: ModuleUpdate;
}
export interface ModuleUpdate {
  status: number;
  progress: number;
  createdAt: number;
}
export interface SolarmanInverterType {
  sn: string;
  arm: string;
  dspm: string;
  dsps: string;
  created: string;
  lastUpdate: string;
  fota_module: string;
  fota_status: string;
  updating: boolean;
  upd_global: ModuleUpdate;
}
export interface SolarmanLanType {
  lte_IMEI: number;
  lte_IMSI: number;
  lte_apnServer: string;
  lte_apnUser: string;
  lte_apnPsw: string;
  lte_ICCID: number;
  lte_strength: number;
  wifi_SSID: string;
  wifi_ip: string;
  wifi_routerIP: string;
  wifi_DNS: string;
  wifi_status: string;
  wifi_enabled: string;
  wifi_online: string;
  wifi_psw: string;
  eth_ip: string;
  eth_routerIP: string;
  eth_DNS: string;
  eth_status: string;
  eth_enabled: string;
  eth_online: string;
}
export interface AzzurroHubDataType {
  config: AzzurroHubConfigType;
  inverter: AHinverterType[];
  meter: AHmeterType[];
  solarSensor: AHsolarSensorType[];
  evChargerCAN: AHevChargerCANType[];
  evCharger485: AHevCharger485Type[];
  pwrMagic: AHpowerMagicType[];
  heatPump: AHheatPumpType[];
  PSC100: AHpsc100Type[];
  info: AzzurroHubInfoType;
  lan: AzzurroHubLanType;
  loggerId: string;
}
export interface AzzurroHubConfigType {
  country: string;
  IANA: string;
  actPwrCtrlAlgo: AHactPwrCtrlAlgoEnum;
  actPwrCtrlEna: boolean;
  actPwrCtrlTarget: number;
  intSensorInversion: AHintSensorInversionEnum;
  maxContractualPwr: number;
  maxPlantInvPwr: number;
  monitoringMode: AHmonitoringModeEnum;
  plantPhases: AHplantPhasesEnum;
  evchCtrlEna: boolean;
  evchTimeModeEna: boolean;
  evchTimeStart: string;
  evchTimeStop: string;
  evchBatteryProtectEna: boolean;
  evchBatterySOCLimit: number;
  evchPwrImportLimit: boolean;
  evchPwrImportValue: number;
  evchParallelEna: boolean;
  evchStrategy: AHevchStrategyEnum;
  scanDevices: AHscanDevicesEnum;
  operational: AHoperationalEnum;
  plantDetectType: AHplantDetectEnum;
  updatedAt: number;
  createdAt: number;
  virtualRTStatus: VirtualRTStateType;
}
export interface AHinverterType {
  deviceType: AHdeviceTypeEnum;
  sn: string;
  connected: boolean;
  removed: boolean;
  modbusAdr: number;
  hwVer: string;
  arm: string;
  dspm: string;
  dsps: string;
  updating: boolean;
  upd_arm: ModuleUpdate;
  upd_dspm: ModuleUpdate;
  upd_dsps: ModuleUpdate;
  upd_safety: ModuleUpdate;
  upd_sofar: ModuleUpdate;
  safetyVer: string;
  country: number;
  region: number;
  updatedAt: number;
  createdAt: number;
}
export interface AHmeterType {
  deviceType: AHdeviceTypeEnum;
  sn: string;
  connected: boolean;
  removed: boolean;
  modbusAdr: number;
  model: AHmodelTypeEnum;
  updatedAt: number;
  createdAt: number;
}
export interface AHsolarSensorType {
  deviceType: AHdeviceTypeEnum;
  sn: string;
  connected: boolean;
  removed: boolean;
  updatedAt: number;
  createdAt: number;
}
export interface AHevChargerCANType {
  deviceType: AHdeviceTypeEnum;
  sn: string;
  connected: boolean;
  removed: boolean;
  sts: AHsts;
  swVer: string;
  type: string;
  alerts: string;
  updatedAt: number;
  createdAt: number;
}
export interface AHevCharger485Type {
  deviceType: AHdeviceTypeEnum;
  sn: string;
  connected: boolean;
  removed: boolean;
  modbusAdr: number;
  sts: AHsts;
  swVer: string;
  alerts: string;
  updatedAt: number;
  createdAt: number;
}
export interface AHpowerMagicType {
  deviceType: AHdeviceTypeEnum;
  sn: string;
  connected: boolean;
  removed: boolean;
  ipAddr: string;
  updatedAt: number;
  createdAt: number;
}
export interface AHheatPumpType {
  deviceType: AHdeviceTypeEnum;
  sn: string;
  connected: boolean;
  removed: boolean;
  updatedAt: number;
  createdAt: number;
  modbusAdr: number;
  globStatus: AHglobStatusEnum;
  DHWOn: boolean;
  climOnA: boolean;
  DHWSetTemp: number;
  climOpMode: AHclimOpModeEnum;
  climSetTempHeatingA: number;
  climSetTempCoolingA: number;
}
export interface AHpsc100Type {
  deviceType: AHdeviceTypeEnum;
  sn: string;
  connected: boolean;
  removed: boolean;
  app: string;
  gcp: string;
  PBUSCCO1: string;
  PBUSCCO2: string;
  core: string;
  sdk: string;
  inverters: AHpsc100InvertersType[];
  updatedAt: number;
  createdAt: number;
}
export interface AHpsc100InvertersType {
  sn: string;
}
export interface AzzurroHubInfoType {
  fw: AHinfoFwType;
  upd: AHinfoLoggerUpgradeType;
  connection: AHConnectionType;
  sn: AHSNType;
  name: AHNameType;
  hwv: AHHwVType;
  def: AHDefType;
}
export interface AHinfoFwType {
  currVer: string;
  shadowVer: string;
  currBootSlot: AHcurrBootSlotEnum;
  bootSts: AHbootStsEnum;
  bootErr: string;
  hwVer: string;
  dateProd: string;
  scriptVer: string;
  updatedAt: number;
  createdAt: number;
}
export interface AHinfoLoggerUpgradeType {
  result: boolean;
  updatedAt: number;
  createdAt: number;
}
export interface AHConnectionType {
  timestamp: number;
  status: string;
  disconnectReason: string;
  ipAddress: string;
}
export interface AHSNType {
  sn: string;
  timestamp: number;
  uid: string;
  type: string;
  updatedAt: number;
  createdAt: number;
}
export interface AHNameType {
  name: string;
  timestamp: number;
}
export interface AHHwVType {
  hwVer: string;
  timestamp: number;
}
export interface AHDefType {
  thingDef: string;
  type: string;
  timestamp: number;
}
export interface AzzurroHubLanType {
  eth_DHCP: boolean;
  eth_DNS1: string;
  eth_DNS2: string;
  eth_enabled: boolean;
  eth_ip: string;
  eth_online: boolean;
  eth_routerIP: string;
  eth_status: AHethStatusEnum;
  wifi_DHCP: boolean;
  wifi_DNS1: string;
  wifi_DNS2: string;
  wifi_enabled: string;
  wifi_ip: string;
  wifi_online: boolean;
  wifi_routerIP: string;
  wifi_SSID: string;
  wifi_status: AHwifiStatusEnum;
  wifi_strength: number;
  updatedAt: number;
  createdAt: number;
}
export interface MyCertifiedPlant {
  plantId: string;
  devices: PlantDeviceType[];
  ems: PlantEmsType[];
  loggers: SolarmanDataType[];
  ems_state: ConnextDataType[];
  ems_state_v2: EmsStateType[];
  users: PlantMyUserType[];
  geo: PlantGeoType;
  config: PlantConfigType;
  plantPref: PlantPrefType;
}
export interface PlantDeviceType {
  sn: string;
  type: PlantDeviceEnumType;
  installationTime: number;
  disinstallationTime: number;
}
export interface PlantEmsType {
  sn: string;
  type: PlantEmsEnumType;
  installationTime: number;
  disinstallationTime: number;
}
export interface PlantMyUserType {
  email: string;
  userLevel: number;
}
export interface PlantGeoType {
  latitude: number;
  longitude: number;
  IANA: string;
}
export interface PlantConfigType {
  contractualPower: number;
  meterInversion: boolean;
  phase: PhaseEnumType;
  monitoringType: PlantMonitoringEnumType;
}
export interface PlantPrefType {
  monitorPref: MonitorPrefEnumType;
  plantName: string;
  tagsDevices: TagsDevicesType[];
}
export interface TagsDevicesType {
  key: string;
  value: string;
}
export interface MyCertifiedPlantId {
  plantId: string;
}
export interface ServicePartnerCertification {
  active: boolean;
  codSoggetto: string;
  codiceAzienda: string;
  companyName: string;
  dataFine: string;
  email: string;
  emailCert: string;
  codInstallatore: string;
  tipoSkill: string;
  tags: string[];
}
export interface BaseCertificationInstaller {
  active: boolean;
  codiceAzienda: string;
  companyName: string;
  dataFine: string;
  email: string;
  emailCert: string;
  codInstallatore: string;
  tipoSkill: string;
  tags: string[];
}
export interface AdvanceCertificationInstaller {
  active: boolean;
  codiceAzienda: string;
  companyName: string;
  dataFine: string;
  email: string;
  emailCert: string;
  codInstallatore: string;
  tipoSkill: string;
  tags: string[];
}
export interface CassiopeaTokenType {
  accessToken: string;
  refreshToken: string;
}
export interface ThirdPartyTokenType {
  token: string;
}
export interface PowerMagicModule {
  nodeId: string;
  path: string;
  treeId: string;
  type: string;
}
export interface AzzurroEventConfigurationDetail {
  eventName: string;
  description: string;
  payloadType: string;
  defaultConfig: AzzurroEventDefaultConfig;
  alertCodes: AzzurroEventAlertCodes;
  generations: GenerationEnum[];
}
export interface AzzurroEventDefaultConfig {
  activeTimeMinutes: number;
  recurringEmailIntervalMinutes: number;
  snoozeDurationMinutes: number;
  voltageThreshold: number;
  socThreshold: number;
  sleepModeDurationMinutes: number;
  minVoltageThreshold: number;
  maxVoltageThreshold: number;
}
export interface AzzurroEventAlertCodes {
  G1: number;
  G1_ZCS: number;
  G2: number;
  G2_ZCS: number;
  G3: number;
  G3_ZCS: number;
}
export interface EventNotificationData {
  events: EventNotificationItem;
  emails: string[];
  plantId: string;
}
export interface EventNotificationItem {
  AcCurrentUnbalanceFault: EventNotificationPayloadBase;
  AcHardwareOvercurrentFault: EventNotificationPayloadBase;
  BatteryLow: EventNotificationBatteryLowPayload;
  BatteryLowVoltageShutdown: EventNotificationPayloadBase;
  BMS1CommunicatonFault: EventNotificationPayloadBase;
  BMS2CommunicatonFault: EventNotificationPayloadBase;
  BMSOvervoltageProtection: EventNotificationPayloadBase;
  BMSUndervoltageProtection: EventNotificationPayloadBase;
  BMSVerFault: EventNotificationPayloadBase;
  ZBTS5kSleepMode: EventNotificationZBTS5kSleepModePayload;
  BusHardwareOvervoltageFault: EventNotificationPayloadBase;
  BusOvervoltageFault: EventNotificationPayloadBase;
  BusUnbalanceFault: EventNotificationPayloadBase;
  CTError: EventNotificationPayloadBase;
  EpsBatteryOvercurrentFault: EventNotificationPayloadBase;
  Fan1Failure: EventNotificationPayloadBase;
  Fan2Failure: EventNotificationPayloadBase;
  Fan3Failure: EventNotificationPayloadBase;
  Fan4Failure: EventNotificationPayloadBase;
  Fan5Failure: EventNotificationPayloadBase;
  Fan6Failure: EventNotificationPayloadBase;
  Fan7Failure: EventNotificationPayloadBase;
  GridOverfrequency: EventNotificationPayloadBase;
  GridOvervoltage: EventNotificationPayloadBase;
  GridUnderfrequency: EventNotificationPayloadBase;
  GridUndervoltage: EventNotificationPayloadBase;
  InconsistentSoftwareVersion: EventNotificationPayloadBase;
  InputModeSettingFailure: EventNotificationPayloadBase;
  InputOvercurrentFault: EventNotificationPayloadBase;
  InverterSoftStartFailure: EventNotificationPayloadBase;
  IslandingError: EventNotificationPayloadBase;
  LeakageCurrentFault: EventNotificationPayloadBase;
  LowInsulationResistance: EventNotificationPayloadBase;
  MeterError: EventNotificationPayloadBase;
  OutputInstantaneousOvercurrentFault: EventNotificationPayloadBase;
  PVOvervoltage: EventNotificationPayloadBase;
  PvUnevenCurrentFault: EventNotificationPayloadBase;
  RelayDetectionFailure: EventNotificationPayloadBase;
  RelayUnbalancedPermanentFailure: EventNotificationPayloadBase;
  SCIError_AC: EventNotificationPayloadBase;
  SCIError_DC: EventNotificationPayloadBase;
  SCIError_Fuse: EventNotificationPayloadBase;
  SPICommError_AC: EventNotificationPayloadBase;
  SPICommError_DC: EventNotificationPayloadBase;
  SafetyVerFault: EventNotificationPayloadBase;
  WeakBattery: EventNotificationWeakBatteryPayload;
  GPMError: EventNotificationPayloadBase;
  GPMWarning: EventNotificationPayloadBase;
  GPMNotice: EventNotificationPayloadBase;
}
export interface EventNotificationPayloadBase {
  activeTimeMinutes: number;
  recurringEmailIntervalMinutes: number;
  snoozeDurationMinutes: number;
  generations: GenerationEnum[];
}
export interface EventNotificationBatteryLowPayload {
  activeTimeMinutes: number;
  recurringEmailIntervalMinutes: number;
  snoozeDurationMinutes: number;
  voltageThreshold: number;
  socThreshold: number;
  generations: GenerationEnum[];
}
export interface EventNotificationZBTS5kSleepModePayload {
  activeTimeMinutes: number;
  recurringEmailIntervalMinutes: number;
  snoozeDurationMinutes: number;
  sleepModeDurationMinutes: number;
  socThreshold: number;
  minVoltageThreshold: number;
  maxVoltageThreshold: number;
  generations: GenerationEnum[];
}
export interface EventNotificationWeakBatteryPayload {
  activeTimeMinutes: number;
  recurringEmailIntervalMinutes: number;
  snoozeDurationMinutes: number;
  voltageThreshold: number;
  generations: GenerationEnum[];
}
export interface AdvancedEventConfiguration {
  emailList: string[];
  eventModelsName: EventModel[];
}
export interface TeseoTokenType {
  access_token: string;
  expires_in: number;
}
export interface PresignedUrlSpReportBucket {
  url: string;
  success: boolean;
}
export interface AdvanceEventOutcomesHistory {
  deviceId: string;
  eventModelName: EventModel;
  open_ts: string;
  close_ts: string;
}
export interface AdvanceEventOutcomes {
  deviceId: string;
  eventModelName: EventModel;
  open_ts: string;
}
export interface CommunicationChannel {
  CommunicationChannel: Channel;
  LoggerModel: string;
  LoggerFirmware: string;
  LoggerStatus: string;
  FotaStatus: number;
}
export interface RDSDevicesStatusType {
  devices: RDSDeviceStatus[];
  totalCount: number;
}
export interface RDSDeviceStatus {
  deviceId: string;
  devType: RDSDeviceTypeEnum;
  batteryModel: BatteryModelEnum;
  arm: string;
  dspm: string;
  dsps: string;
  isInAlarm: boolean;
  hasAzzurroEvents: boolean;
  updatedAt: string;
  createdAt: string;
}
export interface RDSAlertsStatusType {
  alerts: RDSAlertsStatus[];
  totalCount: number;
}
export interface RDSAlertsStatus {
  alertId: number;
  alertName: string;
  arm: string;
  dspm: string;
  dsps: string;
  batteryModel: BatteryModelEnum;
  deviceId: string;
  status: RDSAlertsStatusEnum;
  updatedAt: string;
  createdAt: string;
}
export interface RDSAzzurroEventsType {
  azzurroEvents: RDSAzzurroEvents[];
  totalCount: number;
}
export interface RDSAzzurroEvents {
  azzurroEvent: RDSEventModel;
  arm: string;
  dspm: string;
  dsps: string;
  batteryModel: BatteryModelEnum;
  deviceId: string;
  status: RDSAzzurroEventsEnum;
  updatedAt: string;
  createdAt: string;
}
export interface SolarmanPasswordResult {
  password: string;
  errorCode: number;
  errorMessage: string;
}
export interface CMDReq {
  deviceId: string;
  timestamp: number;
  transactionId: string;
  clientId: string;
  action: ActionRes;
}
export interface ConnexTAPIRes {
  deviceId: string;
}
export interface CMDRes {
  deviceId: string;
  timestamp: number;
  transactionId: string;
  clientId: string;
  action: ActionRes;
}
export interface ConnextUpdateResponse {
  success: boolean;
  version: string;
  transactionId: string;
  msg: string;
}
export interface DevicesAPIRes {
  deviceId: number;
  ack: string;
  analysisResult: string;
  content: string;
  createTime: number;
  deviceSN: string;
  orderId: number;
  success: boolean;
  updateTime: number;
}
export interface ThirdPartyCredentials {
  email: string;
  token: string;
}
export interface PlantType {
  plantId: string;
  createTime: string;
}
export interface UpdatePlantStatusType {
  email: string[];
  changesPath: string[];
  operationType: string;
  plant: MyCertifiedPlant[];
}
export interface CertifiedPlantType {
  success: boolean;
  statusCode: number;
  message: string;
}
export interface CreateCertifiedPlantType {
  plantId: string;
  statusCode: number;
  message: string;
}
export interface UpgradeInverterResponse {
  deviceId: string;
  correlationId: string;
}
export interface SendCommandStringResponse {
  collectionTime: number;
  orderId: string;
  success: boolean;
  code: string;
  msg: string;
  connectStatus: number;
}
export interface ReceiveCommandStringResponse {
  transactionId: string;
  version: string;
  loggerId: string;
  inverterId: string;
  timestamp: number;
  dataType: string;
  result: string;
  commandResponse: string;
}
export interface EventNotificationConfig {
  success: boolean;
  data: EventNotificationData;
  errors: EventNotificationError[];
}
export interface EventNotificationError {
  eventModelName: EventModel;
  errorType: ErrorType;
  message: string;
}
export interface SendCommandForLoggerEthResponse {
  loggerId: string;
  inverterId: string;
  action: string;
  command: string;
  timestamp: number;
  transactionId: string;
}
export interface SendInvUpgradeResponse {
  transactionId: string;
  inverterId: string;
  loggerId: string;
  timestamp: number;
  fileType: string;
  totalSize: string;
  fileCRC: string;
  fileURL: string;
}
export interface ReceiveInvUpgradeResponse {
  transactionId: string;
  version: string;
  loggerId: string;
  timestamp: number;
  dataType: string;
  result: string;
  fileType: string;
  message: string;
}
export interface ReceiveInvUpgradeByEthResponse {
  transactionId: string;
  cid: string;
  loggerId: string;
  inverterId: string;
  timestamp: number;
  result: string;
  fileType: string;
}
export interface ResponseStatusType {
  success: boolean;
  statusCode: number;
  message: string;
}
export interface MigrateSunflowerResponse {
  message: string;
  success: boolean;
}
export interface ReceiveAckResponse {
  transactionId: string;
  version: string;
  deviceId: string;
  timestamp: number;
  dataType: AzzurroHubAction;
  message: string;
  success: boolean;
}
export interface RmsJob {
  jobId: string;
  status: string;
  startedAt: string;
}
export interface SendInvUpgradeByAHResponse {
  transactionId: string;
  inverterId: string;
  loggerId: string;
  timestamp: number;
  input: SendInvUpgradeByAHOutput[];
}
export interface SendInvUpgradeByAHOutput {
  fileType: string;
  fileCRC: string;
  fileURL: string;
  fileSize: string;
  CC: string;
  CR: string;
}
export interface AzzurroHubModbusRes {
  id: string;
  version: string;
  deviceSN: string;
  gatewaySN: string;
  deviceType: string;
  timestamp: number;
  dataType: string;
  dataMap: ResponseModbusCommandsAttributes[];
}
export interface ResponseModbusCommandsAttributes {
  groupID: number;
  result: string;
  commandResponse: string;
}
export interface startVirtualRTAzzurroHubResponse {
  success: boolean;
  msg: string;
  code: string;
}
export interface VirtualRTTelemetryType {
  deviceId: string;
  loggerId: string;
  target: VirtualRTAzzurroHubTarget;
  ZZ: InverterV2;
}
export interface InverterDay {
  EG1: string;
  EG2: string;
  EG3: string;
  EG4: string;
  EG5: string;
  EG6: string;
}
export interface InverterMonth {
  EM1: string;
  EM2: string;
  EM3: string;
  EM4: string;
  EM5: string;
  EM6: string;
}
export interface PlantMyConfigType {
  meterInversion: boolean;
}
export interface CMDSendAck {
  deviceId: string;
  timestamp: number;
  transactionId: string;
  clientId: string;
  msgCode: number;
}
export interface DevicesBodyRes {
  ack: string;
  analysisResult: string;
  content: string;
  createTime: string;
  deviceSN: string;
  orderId: string;
  success: boolean;
  updateTime: string;
}
export interface PlantUserType {
  email: string;
  userLevel: number;
  plantName: string;
  latitude: string;
  longitude: string;
  IANA: string;
  meterInversion: boolean;
  uid: string;
  plantsUidList: string[];
  tigoId: number;
}
export interface PlantConflictType {
  conflictId: string;
}

export interface Range {
  from: string;
  to: string;
}
export interface Page {
  nextToken?: string;
  limit?: number;
}
export interface RDSDevicesStatusInput {
  filter?: RDSDevicesStatusFilter;
  pagination?: RDSPaginationInput;
  sort?: RDSDevicesSortInput;
}
export interface RDSDevicesStatusFilter {
  deviceId?: string;
  isInAlarm?: boolean;
  type?: RDSDeviceTypeEnum;
  batteryModel?: BatteryModelEnum;
  arm?: string;
  dspm?: string;
  dsps?: string;
  hasAzzurroEvents?: boolean;
}
export interface RDSPaginationInput {
  pageSize: number;
  pageIndex: number;
}
export interface RDSDevicesSortInput {
  column?: RDSDeviceSortEnum;
  sortDirection?: RDSSortDirectionEnum;
}
export interface RDSAlertsStatusInput {
  filter?: RDSAlertsStatusFilter;
  pagination?: RDSPaginationInput;
  sort?: RDSAlertsSortInput;
}
export interface RDSAlertsStatusFilter {
  alertIdByGeneration?: RDSAlertByGenerationInput;
  arm?: string;
  dspm?: string;
  dsps?: string;
  deviceId?: string;
  batteryModel?: BatteryModelEnum;
  status?: RDSAlertsStatusEnum;
}
export interface RDSAlertByGenerationInput {
  alertId?: number;
  generation?: RDSGenerationEnum;
}
export interface RDSAlertsSortInput {
  column?: RDSAlertsSortEnum;
  sortDirection?: RDSSortDirectionEnum;
}
export interface RDSAzzurroEventsInput {
  filter?: RDSAzzurroEventsFilter;
  pagination?: RDSPaginationInput;
  sort?: RDSAzzurroEventsSortInput;
}
export interface RDSAzzurroEventsFilter {
  azzurroEvent?: RDSEventModel;
  arm?: string;
  dspm?: string;
  dsps?: string;
  deviceId?: string;
  batteryModel?: BatteryModelEnum;
  status?: RDSAzzurroEventsEnum;
}
export interface RDSAzzurroEventsSortInput {
  column?: RDSAzzurroEventsSortEnum;
  sortDirection?: RDSSortDirectionEnum;
}
export interface actionCMD {
  args?: string[];
  cmd: string;
}
export interface actionRes {
  msg?: string;
  success: boolean;
  msgCode?: number;
}
export interface ModbusCommandLog {
  deviceId: string;
  timestamp: number;
  request?: string;
  response?: string;
}
export interface UpdatePlantStatusInput {
  email?: string[];
  changesPath?: string[];
  operationType?: string;
  plant?: MyCertifiedPlantInput[];
}
export interface MyCertifiedPlantInput {
  plantId?: string;
  devices?: PlantDeviceInput[];
  ems?: PlantEmsInput[];
  loggers?: SolarmanDataInput[];
  ems_state?: ConnextDataInput[];
  ems_state_v2?: EmsStateInput[];
  users?: PlantMyUserInput[];
  geo?: PlantGeoInput;
  config?: PlantConfigInput;
  plantPref?: PlantPrefInput;
}
export interface PlantDeviceInput {
  sn: string;
  type: PlantDeviceEnumType;
  installationTime: number;
  disinstallationTime?: number;
}
export interface PlantEmsInput {
  sn: string;
  type: PlantEmsEnumType;
  installationTime: number;
  disinstallationTime?: number;
}
export interface SolarmanDataInput {
  loggerId?: string;
  info?: SolarmanInfoInput;
  devices?: SolarmanDeviceInput[];
  inverter?: SolarmanInverterInput[];
  lan?: SolarmanLanInput;
}
export interface SolarmanInfoInput {
  name?: SolarmanNameInput;
  fw?: SolarmanFwInput;
  hwv?: SolarmanHwVInput;
  def?: SolarmanDefInput;
  connection?: SolarmanConnectionInput;
}
export interface SolarmanNameInput {
  name?: string;
  timestamp?: number;
}
export interface SolarmanFwInput {
  cfgFileName?: string;
  cfgFileVer?: string;
  firmwareVer?: string;
  hardwareVer?: string;
  manufacturer?: string;
  model?: string;
  sn?: string;
}
export interface SolarmanHwVInput {
  hwVer?: string;
  timestamp?: number;
}
export interface SolarmanDefInput {
  thingDef?: string;
  type?: string;
  timestamp?: number;
}
export interface SolarmanConnectionInput {
  timestamp?: number;
  status?: string;
  disconnectReason?: string;
  ipAddress?: string;
}
export interface SolarmanDeviceInput {
  sn?: string;
  arm?: string;
  dspm?: string;
  dsps?: string;
  created?: string;
  lastUpdate?: string;
  fota_module?: string;
  fota_status?: string;
  updating?: boolean;
  upd_global?: ModuleUpdateInput;
}
export interface ModuleUpdateInput {
  status?: number;
  progress?: number;
  createdAt?: number;
}
export interface SolarmanInverterInput {
  sn?: string;
  arm?: string;
  dspm?: string;
  dsps?: string;
  created?: string;
  lastUpdate?: string;
  fota_module?: string;
  fota_status?: string;
  updating?: boolean;
  upd_global?: ModuleUpdateInput;
}
export interface SolarmanLanInput {
  lte_IMEI?: number;
  lte_IMSI?: number;
  lte_apnServer?: string;
  lte_apnUser?: string;
  lte_apnPsw?: string;
  lte_ICCID?: number;
  lte_strength?: number;
  wifi_SSID?: string;
  wifi_ip?: string;
  wifi_routerIP?: string;
  wifi_DNS?: string;
  wifi_status?: string;
  wifi_enabled?: string;
  wifi_online?: string;
  wifi_psw?: string;
  eth_ip?: string;
  eth_routerIP?: string;
  eth_DNS?: string;
  eth_status?: string;
  eth_enabled?: string;
  eth_online?: string;
}
export interface ConnextDataInput {
  loggerId?: string;
  info?: ConnextInfoInput;
  devices?: ConnextInverterInput[];
  evch?: ConnextEvChInput[];
  io?: ConnextIOInput[];
  config?: ConnextConfigInput;
}
export interface ConnextInfoInput {
  sn?: ConnextSNInput;
  name?: ConnextNameInput;
  fw?: ConnextFwInput;
  hwv?: ConnextHwVInput;
  def?: ConnextDefInput;
  connection?: ConnextConnectionInput;
  cell_info?: ConnextCellInfoInput;
}
export interface ConnextSNInput {
  sn?: string;
  timestamp?: number;
  uid?: string;
  type?: string;
  updatedAt?: number;
  createdAt?: number;
}
export interface ConnextNameInput {
  name?: string;
  timestamp?: number;
}
export interface ConnextFwInput {
  fota_status?: string;
  timestamp?: number;
  type?: string;
  fw_ver?: string;
  fwCategory?: number;
  updatedAt?: number;
  createdAt?: number;
}
export interface ConnextHwVInput {
  hwVer?: string;
  timestamp?: number;
}
export interface ConnextDefInput {
  thingDef?: string;
  type?: string;
  timestamp?: number;
}
export interface ConnextConnectionInput {
  timestamp?: number;
  status?: string;
  disconnectReason?: string;
  ipAddress?: string;
}
export interface ConnextCellInfoInput {
  imei?: string;
  cell_model?: string;
  icc_id?: string;
  updatedAt?: number;
  cell_revision?: string;
  cell_serial?: string;
}
export interface ConnextInverterInput {
  type?: string;
  model?: string;
  cmd?: string;
  dModel?: string;
  sn?: string;
  active?: number;
  timestamp?: number;
  id?: number;
  id_list?: number;
  modbus_address?: number;
  d2evc?: number;
  threeF?: number;
  version?: string;
  thingDef?: string;
  sensor_mode?: number;
  registered?: number;
  rgistered?: number;
  k?: number;
  dsps?: string;
  dspm?: string;
  arm?: string;
  fw_rev?: string;
  grid_meter?: number;
}
export interface ConnextEvChInput {
  type?: string;
  dModel?: string;
  model?: string;
  sn?: string;
  active?: number;
  timestamp?: number;
  limitPower?: number;
  chargerMode?: number;
  carConsumption?: number;
  fwVer?: string;
  startTime?: string;
  tStart?: number;
  tpDuration?: number;
  tpPower?: number;
  inputGreenPower?: number;
  status?: number;
  rsn?: number;
  maxpw?: number;
  st_cmd?: number;
  ready?: number;
  wb_err_id?: number;
  wb_err_ts?: number;
  error_id?: number;
  error_ts?: number;
  rt_exp?: number;
  updatedAt?: number;
  createdAt?: number;
}
export interface ConnextIOInput {
  index?: number;
  active?: number;
  name?: string;
  out1?: number;
  var1?: number;
  thH?: number;
  thL?: number;
  time_th?: number;
  time_tl?: number;
  thH1?: number;
  thL1?: number;
  time_th1?: number;
  time_tl1?: number;
  t_min?: number;
  d_start?: number;
  d_stop?: number;
  t0_start?: number;
  t1_start?: number;
  t2_start?: number;
  t3_start?: number;
  t4_start?: number;
  t5_start?: number;
  t6_start?: number;
  t0_stop?: number;
  t1_stop?: number;
  t2_stop?: number;
  t3_stop?: number;
  t4_stop?: number;
  t5_stop?: number;
  t6_stop?: number;
  n_out?: number;
  level?: string;
  function?: number;
  out_state?: number;
  description?: string;
  src?: string;
  templateId?: string;
}
export interface ConnextConfigInput {
  timestamp?: number;
  maxLoadPwr?: number;
  plantCurrSensO?: number;
  plantCurrSensTR?: number;
  invCurrSensO?: number;
  invCurrSensTR?: number;
  TZ?: string;
  latitude?: number;
  longitude?: number;
  pType?: number;
  io_cnt_func?: number;
  io_out_used?: number;
  io_ing_used?: number;
  sensor_mode?: number;
  ext_device?: number;
  connection?: number;
  net?: number;
  configVerified?: boolean;
  mt_sign?: number;
  mt_active?: number;
  mt_pb?: number;
  tas_en?: number;
  tas_pb?: number;
  tap_en?: number;
  tap_pb?: number;
  num_device?: number;
  ta_sign?: number;
  pext?: number;
  error_id?: number;
  error_ts?: number;
  virtualRTStatus?: VirtualRTStateInput;
}
export interface VirtualRTStateInput {
  active?: boolean;
  startTS?: number;
  duration?: number;
  target?: string;
}
export interface EmsStateInput {
  connext?: ConnextDataInput;
  azzurro_hub?: AzzurroHubDataInput;
}
export interface AzzurroHubDataInput {
  config?: AzzurroHubConfigInput;
  inverter?: AHinverterInput[];
  meter?: AHmeterInput[];
  evChargerCAN?: AHevChargerCANInput[];
  evCharger485?: AHevCharger485Input[];
  pwrMagic?: AHpowerMagicInput[];
  heatPump?: AHheatPumpInput[];
  solarSensor?: AHsolarSensorInput[];
  PSC100?: AHpsc100Input[];
  info?: AzzurroHubInfoInput;
  lan?: AzzurroHubLanInput;
  loggerId?: string;
}
export interface AzzurroHubConfigInput {
  country?: string;
  IANA?: string;
  actPwrCtrlAlgo?: AHactPwrCtrlAlgoEnum;
  actPwrCtrlEna?: boolean;
  actPwrCtrlTarget?: number;
  intSensorInversion?: AHintSensorInversionEnum;
  maxContractualPwr?: number;
  maxPlantInvPwr?: number;
  monitoringMode?: AHmonitoringModeEnum;
  plantPhases?: AHplantPhasesEnum;
  evchCtrlEna?: boolean;
  evchTimeModeEna?: boolean;
  evchTimeStart?: string;
  evchTimeStop?: string;
  evchBatteryProtectEna?: boolean;
  evchBatterySOCLimit?: number;
  evchPwrImportLimit?: boolean;
  evchPwrImportValue?: number;
  evchParallelEna?: boolean;
  evchStrategy?: AHevchStrategyEnum;
  scanDevices?: AHscanDevicesEnum;
  operational?: AHoperationalEnum;
  plantDetectType?: AHplantDetectEnum;
  updatedAt?: number;
  createdAt?: number;
  virtualRTStatus?: VirtualRTStateInput;
}
export interface AHinverterInput {
  deviceType?: AHdeviceTypeEnum;
  sn?: string;
  connected?: boolean;
  removed?: boolean;
  modbusAdr?: number;
  hwVer?: string;
  arm?: string;
  dspm?: string;
  dsps?: string;
  updating?: boolean;
  upd_arm?: ModuleUpdateInput;
  upd_dspm?: ModuleUpdateInput;
  upd_dsps?: ModuleUpdateInput;
  upd_safety?: ModuleUpdateInput;
  upd_sofar?: ModuleUpdateInput;
  safetyVer?: string;
  country?: number;
  region?: number;
  updatedAt?: number;
  createdAt?: number;
}
export interface AHmeterInput {
  deviceType?: AHdeviceTypeEnum;
  sn?: string;
  connected?: boolean;
  removed?: boolean;
  modbusAdr?: number;
  model?: AHmodelTypeEnum;
  updatedAt?: number;
  createdAt?: number;
}
export interface AHevChargerCANInput {
  deviceType?: AHdeviceTypeEnum;
  sn?: string;
  connected?: boolean;
  removed?: boolean;
  sts?: AHsts;
  swVer?: string;
  type?: string;
  alerts?: string;
  updatedAt?: number;
  createdAt?: number;
}
export interface AHevCharger485Input {
  deviceType?: AHdeviceTypeEnum;
  sn?: string;
  connected?: boolean;
  removed?: boolean;
  modbusAdr?: number;
  sts?: AHsts;
  swVer?: string;
  alerts?: string;
  updatedAt?: number;
  createdAt?: number;
}
export interface AHpowerMagicInput {
  deviceType?: AHdeviceTypeEnum;
  sn?: string;
  connected?: boolean;
  removed?: boolean;
  ipAddr?: string;
  updatedAt?: number;
  createdAt?: number;
}
export interface AHheatPumpInput {
  deviceType?: AHdeviceTypeEnum;
  sn?: string;
  connected?: boolean;
  removed?: boolean;
  updatedAt?: number;
  createdAt?: number;
  modbusAdr?: number;
  globStatus?: AHglobStatusEnum;
  DHWOn?: boolean;
  climOnA?: boolean;
  DHWSetTemp?: number;
  climOpMode?: AHclimOpModeEnum;
  climSetTempHeatingA?: number;
  climSetTempCoolingA?: number;
}
export interface AHsolarSensorInput {
  deviceType?: AHdeviceTypeEnum;
  sn?: string;
  connected?: boolean;
  removed?: boolean;
  updatedAt?: number;
  createdAt?: number;
}
export interface AHpsc100Input {
  deviceType?: AHdeviceTypeEnum;
  sn?: string;
  connected?: boolean;
  removed?: boolean;
  app?: string;
  gcp?: string;
  PBUSCCO1?: string;
  PBUSCCO2?: string;
  core?: string;
  sdk?: string;
  inverters?: AHpsc100InvertersInput[];
  updatedAt?: number;
  createdAt?: number;
}
export interface AHpsc100InvertersInput {
  sn?: string;
}
export interface AzzurroHubInfoInput {
  fw?: AHinfoFwInput;
  upd?: AHinfoLoggerUpgradeInput;
  connection?: AHConnectionInput;
  sn?: AHSNInput;
  name?: AHNameInput;
  hwv?: AHHwVInput;
  def?: AHDefInput;
}
export interface AHinfoFwInput {
  currVer?: string;
  shadowVer?: string;
  currBootSlot?: AHcurrBootSlotEnum;
  bootSts?: AHbootStsEnum;
  bootErr?: string;
  hwVer?: string;
  dateProd?: string;
  scriptVer?: string;
  updatedAt?: number;
  createdAt?: number;
}
export interface AHinfoLoggerUpgradeInput {
  result?: boolean;
  updatedAt?: number;
  createdAt?: number;
}
export interface AHConnectionInput {
  timestamp?: number;
  status?: string;
  disconnectReason?: string;
  ipAddress?: string;
}
export interface AHSNInput {
  sn?: string;
  timestamp?: number;
  uid?: string;
  type?: string;
  updatedAt?: number;
  createdAt?: number;
}
export interface AHNameInput {
  name?: string;
  timestamp?: number;
}
export interface AHHwVInput {
  hwVer?: string;
  timestamp?: number;
}
export interface AHDefInput {
  thingDef?: string;
  type?: string;
  timestamp?: number;
}
export interface AzzurroHubLanInput {
  eth_DHCP?: boolean;
  eth_DNS1?: string;
  eth_DNS2?: string;
  eth_enabled?: boolean;
  eth_ip?: string;
  eth_online?: boolean;
  eth_routerIP?: string;
  eth_status?: AHethStatusEnum;
  wifi_DHCP?: boolean;
  wifi_DNS1?: string;
  wifi_DNS2?: string;
  wifi_enabled?: string;
  wifi_ip?: string;
  wifi_online?: boolean;
  wifi_routerIP?: string;
  wifi_SSID?: string;
  wifi_status?: AHwifiStatusEnum;
  wifi_strength?: number;
  updatedAt?: number;
  createdAt?: number;
}
export interface PlantMyUserInput {
  email: string;
  userLevel: number;
}
export interface PlantGeoInput {
  latitude?: number;
  longitude?: number;
  IANA?: string;
}
export interface PlantConfigInput {
  contractualPower?: number;
  meterInversion?: boolean;
  phase?: PhaseEnumType;
  monitoringType?: PlantMonitoringEnumType;
}
export interface PlantPrefInput {
  monitorPref?: MonitorPrefEnumType;
  plantName?: string;
  tagsDevices?: TagsDevicesInput[];
}
export interface TagsDevicesInput {
  key: string;
  value: string;
}
export interface CreateCertifiedPlant {
  config?: PlantConfigInput;
  devices: CreatePlantDeviceInput[];
  ems?: CreatePlantEmsInput;
  users: CreatePlantUserInput[];
  plantUserPrefs: CreatePlantUserPrefInput;
  geo: PlantGeoInput;
}
export interface CreatePlantDeviceInput {
  sn: string;
  type: PlantDeviceEnumType;
  installationTime: number;
}
export interface CreatePlantEmsInput {
  sn: string;
  type: PlantEmsEnumType;
  installationTime: number;
}
export interface CreatePlantUserInput {
  email: string;
  userLevel: number;
}
export interface CreatePlantUserPrefInput {
  monitorPref: MonitorPrefEnumType;
  plantName: string;
  tagsDevices?: TagsDevicesInput[];
}
export interface ReceiveCommandStringInput {
  transactionId?: string;
  version?: string;
  deviceId?: string;
  inverterId?: string;
  timestamp?: number;
  dataType?: string;
  result?: string;
  commandResponse?: string;
}
export interface AdvancedEventConfigurationInput {
  emailList?: string[];
  eventModelsName?: EventModel[];
}
export interface EventNotificationConfigInput {
  eventsOperation: EventsOperation;
  events?: EventNotificationItemInput;
  emails?: string[];
}
export interface EventNotificationItemInput {
  AcCurrentUnbalanceFault?: EventNotificationPayloadBaseInput;
  AcHardwareOvercurrentFault?: EventNotificationPayloadBaseInput;
  BatteryLow?: EventNotificationBatteryLowPayloadInput;
  BatteryLowVoltageShutdown?: EventNotificationPayloadBaseInput;
  BMS1CommunicatonFault?: EventNotificationPayloadBaseInput;
  BMS2CommunicatonFault?: EventNotificationPayloadBaseInput;
  BMSOvervoltageProtection?: EventNotificationPayloadBaseInput;
  BMSUndervoltageProtection?: EventNotificationPayloadBaseInput;
  BMSVerFault?: EventNotificationPayloadBaseInput;
  ZBTS5kSleepMode?: EventNotificationZBTS5kSleepModePayloadInput;
  BusHardwareOvervoltageFault?: EventNotificationPayloadBaseInput;
  BusOvervoltageFault?: EventNotificationPayloadBaseInput;
  BusUnbalanceFault?: EventNotificationPayloadBaseInput;
  CTError?: EventNotificationPayloadBaseInput;
  EpsBatteryOvercurrentFault?: EventNotificationPayloadBaseInput;
  Fan1Failure?: EventNotificationPayloadBaseInput;
  Fan2Failure?: EventNotificationPayloadBaseInput;
  Fan3Failure?: EventNotificationPayloadBaseInput;
  Fan4Failure?: EventNotificationPayloadBaseInput;
  Fan5Failure?: EventNotificationPayloadBaseInput;
  Fan6Failure?: EventNotificationPayloadBaseInput;
  Fan7Failure?: EventNotificationPayloadBaseInput;
  GridOverfrequency?: EventNotificationPayloadBaseInput;
  GridOvervoltage?: EventNotificationPayloadBaseInput;
  GridUnderfrequency?: EventNotificationPayloadBaseInput;
  GridUndervoltage?: EventNotificationPayloadBaseInput;
  InconsistentSoftwareVersion?: EventNotificationPayloadBaseInput;
  InputModeSettingFailure?: EventNotificationPayloadBaseInput;
  InputOvercurrentFault?: EventNotificationPayloadBaseInput;
  InverterSoftStartFailure?: EventNotificationPayloadBaseInput;
  IslandingError?: EventNotificationPayloadBaseInput;
  LeakageCurrentFault?: EventNotificationPayloadBaseInput;
  LowInsulationResistance?: EventNotificationPayloadBaseInput;
  MeterError?: EventNotificationPayloadBaseInput;
  OutputInstantaneousOvercurrentFault?: EventNotificationPayloadBaseInput;
  PVOvervoltage?: EventNotificationPayloadBaseInput;
  PvUnevenCurrentFault?: EventNotificationPayloadBaseInput;
  RelayDetectionFailure?: EventNotificationPayloadBaseInput;
  RelayUnbalancedPermanentFailure?: EventNotificationPayloadBaseInput;
  SCIError_AC?: EventNotificationPayloadBaseInput;
  SCIError_DC?: EventNotificationPayloadBaseInput;
  SCIError_Fuse?: EventNotificationPayloadBaseInput;
  SPICommError_AC?: EventNotificationPayloadBaseInput;
  SPICommError_DC?: EventNotificationPayloadBaseInput;
  SafetyVerFault?: EventNotificationPayloadBaseInput;
  WeakBattery?: EventNotificationWeakBatteryPayloadInput;
  GPMError?: EventNotificationPayloadBaseInput;
  GPMWarning?: EventNotificationPayloadBaseInput;
  GPMNotice?: EventNotificationPayloadBaseInput;
}
export interface EventNotificationPayloadBaseInput {
  activeTimeMinutes?: number;
  recurringEmailIntervalMinutes?: number;
  snoozeDurationMinutes?: number;
}
export interface EventNotificationBatteryLowPayloadInput {
  activeTimeMinutes?: number;
  recurringEmailIntervalMinutes?: number;
  snoozeDurationMinutes?: number;
  voltageThreshold?: number;
  socThreshold?: number;
}
export interface EventNotificationZBTS5kSleepModePayloadInput {
  activeTimeMinutes?: number;
  recurringEmailIntervalMinutes?: number;
  snoozeDurationMinutes?: number;
  sleepModeDurationMinutes?: number;
  socThreshold?: number;
  minVoltageThreshold?: number;
  maxVoltageThreshold?: number;
}
export interface EventNotificationWeakBatteryPayloadInput {
  activeTimeMinutes?: number;
  recurringEmailIntervalMinutes?: number;
  snoozeDurationMinutes?: number;
  voltageThreshold?: number;
}
export interface SendInvUpgradeInput {
  loggerId?: string;
  inverterId?: string;
  fileType?: number;
  fileCRC?: string;
  fileURL?: string;
  fileSize?: string;
}
export interface ReceiveInvUpgradeInput {
  transactionId?: string;
  version?: string;
  deviceId?: string;
  timestamp?: number;
  dataType?: string;
  result?: string;
  fileType?: string;
  message?: string;
}
export interface ReceiveInvUpgradeByEthInput {
  transactionId?: string;
  cid?: string;
  s?: string;
  d?: string;
  timestamp?: number;
  st?: string;
  mod?: string;
}
export interface LoggerUpdateLog {
  device_sn?: string;
  timestamp?: number;
  starting_version?: string;
  target_version?: string;
}
export interface DeviceUpdateLog {
  device_sn?: string;
  timestamp?: number;
  starting_version?: string;
  target_version?: string;
  upgrading_module?: string;
  gateway_sn?: string;
}
export interface DeviceCommandLog {
  device_sn?: string;
  timestamp?: number;
  param_name?: string;
  param_value?: string;
  gateway_sn?: string;
  string_log?: string;
  category?: string;
}
export interface MigrateSunflowerInput {
  email: string;
  password: string;
}
export interface AzzurroHubBody {
  changeDeviceStatus?: ChangeDeviceStatusInput;
  changeLoggerConfig?: ChangeLoggerConfigInput;
  changePlantConfig?: ChangePlantConfigInput;
}
export interface ChangeDeviceStatusInput {
  operation?: AzzurroHubOperation;
}
export interface ChangeLoggerConfigInput {
  country?: string;
  IANA?: string;
}
export interface ChangePlantConfigInput {
  actPwrCtrlAlgo?: ActPwrCtrlAlgoInput;
  actPwrCtrlEna?: boolean;
  actPwrCtrlTarget?: number;
  intSensorInversion?: IntSensorInversionInput;
  maxContractualPwr?: number;
  maxPlantInvPwr?: number;
  monitoringMode?: MonitoringModeInput;
  plantPhases?: PlantPhasesInput;
  evchCtrlEna?: boolean;
  evchTimeModeEna?: boolean;
  evchTimeStart?: string;
  evchTimeStop?: string;
  evchBatteryProtectEna?: boolean;
  evchBatterySOCLimit?: number;
  evchPwrImportLimit?: boolean;
  evchPwrImportValue?: number;
  evchParallelEna?: boolean;
  evchStrategy?: EvchStrategyInput;
}
export interface ReceiveAckRequest {
  transactionId?: string;
  version?: string;
  deviceId?: string;
  timestamp?: number;
  dataType?: AzzurroHubAction;
  message?: string;
  success?: boolean;
}
export interface ChangeAhHeatPumpConfigBody {
  DHWOn?: boolean;
  climOnA?: boolean;
  DHWSetTemp?: number;
  climOpMode?: AHclimOpModeEnum;
  climSetTempHeatingA?: number;
  climSetTempCoolingA?: number;
  sn: string;
}
export interface ModbusCommandsAttributes {
  commandString?: string;
  expectedRetByte?: number;
}
export interface SendInvUpgradeByAHInput {
  fileType?: string;
  fileCRC?: string;
  fileURL?: string;
  fileSize?: string;
  CC?: string;
  CR?: string;
}
export interface InverterUpgradeInput {
  hub?: AzzurroHubUpgradeInput;
  solarman?: SolarmanUpgradeInput;
}
export interface AzzurroHubUpgradeInput {
  loggerId: string;
  deviceSN: string;
  deviceType: AHdeviceTypeEnum;
  transactionId: string;
  packages: SendInvUpgradeByAHInput[];
}
export interface SolarmanUpgradeInput {
  iot?: SolarmanIotUpgradeInput;
  api?: SolarmanApiUpgradeInput;
}
export interface SolarmanIotUpgradeInput {
  loggerId: string;
  inverterId: string;
  fileType?: number;
  fileCRC?: string;
  fileURL?: string;
  fileSize?: string;
}
export interface SolarmanApiUpgradeInput {
  loggerId: string;
  deviceSN: string;
  timeoutSeconds: number;
  packages: SolarmanPackageInput[];
}
export interface SolarmanPackageInput {
  ipUrl: string;
  domainUrl: string;
  name: string;
  size: number;
  crc: string;
  expectedVersion?: string;
}
export interface ReceiveModbusCommandForAHinput {
  id?: string;
  version?: string;
  deviceSN?: string;
  gatewaySN?: string;
  deviceType?: string;
  timestamp?: number;
  dataType?: string;
  dataMap?: ResponseModbusCommandsAttributesInput[];
}
export interface ResponseModbusCommandsAttributesInput {
  groupID?: number;
  result?: string;
  commandResponse?: string;
}
export interface VirtualRTTelemetryInput {
  deviceId?: string;
  loggerId?: string;
  target?: VirtualRTAzzurroHubTarget;
  ZZ?: InverterV2Input;
}
export interface InverterV2Input {
  created?: number;
  GwId?: string;
  ALERTS?: string;
  ALERTS_ZCS?: string;
  ARM?: string;
  DSPM?: string;
  DSPS?: string;
  BP?: string;
  BP1?: string;
  BP2?: string;
  BT?: string;
  BT1?: string;
  BT2?: string;
  BC?: string;
  BC1?: string;
  BC2?: string;
  BN1?: string;
  BN2?: string;
  EG1?: string;
  EG2?: string;
  EG3?: string;
  EG4?: string;
  EG5?: string;
  EG6?: string;
  ET1?: string;
  ET2?: string;
  ET3?: string;
  ET4?: string;
  ET5?: string;
  ET6?: string;
  FC1?: string;
  FC2?: string;
  FC3?: string;
  FR?: string;
  FT1?: string;
  FT2?: string;
  FT3?: string;
  P_1AB?: string;
  P_1AO?: string;
  P_AC_HYD?: string;
  MP1?: string;
  MP2?: string;
  MP3?: string;
  MP4?: string;
  MP5?: string;
  MP6?: string;
  MP7?: string;
  MP8?: string;
  MP9?: string;
  MP10?: string;
  MP11?: string;
  MP12?: string;
  MT1?: string;
  MT2?: string;
  MT3?: string;
  MT4?: string;
  MT5?: string;
  MT6?: string;
  MT7?: string;
  MT8?: string;
  MT9?: string;
  MT10?: string;
  MT11?: string;
  MT12?: string;
  MC1?: string;
  MC2?: string;
  MC3?: string;
  MC4?: string;
  MC5?: string;
  MC6?: string;
  MC7?: string;
  MC8?: string;
  MC9?: string;
  MC10?: string;
  MC11?: string;
  MC12?: string;
  N_MPPT?: string;
  N_MAX_MPPT?: string;
  N_MAX_STRINGS?: string;
  P_B1?: string;
  P_B2?: string;
  P_B_AGGR?: string;
  P_BATTERY_LOAD?: string;
  P_DC_TOT?: string;
  P_EXP?: string;
  P_EXT?: string;
  P_LOAD?: string;
  P_SELF?: string;
  PK?: string;
  SK?: string;
  SC1?: string;
  SC2?: string;
  SC3?: string;
  SC4?: string;
  SC5?: string;
  SC6?: string;
  SC7?: string;
  SC8?: string;
  SC9?: string;
  SC10?: string;
  SC11?: string;
  SC12?: string;
  SC13?: string;
  SC14?: string;
  SC15?: string;
  SC16?: string;
  SC17?: string;
  SC18?: string;
  SC19?: string;
  SC20?: string;
  SC21?: string;
  SC22?: string;
  SC23?: string;
  SC24?: string;
  ST1?: string;
  ST2?: string;
  ST3?: string;
  ST4?: string;
  ST5?: string;
  ST6?: string;
  ST7?: string;
  ST8?: string;
  ST9?: string;
  ST10?: string;
  ST11?: string;
  ST12?: string;
  TB?: string;
  TB1?: string;
  TB2?: string;
  TI?: string;
  TYPE?: string;
  SOL_TEMP?: number;
  SOL_IRR?: number;
  SOL_EG?: number;
  TS?: number;
  TZ?: string;
  V?: number;
}
export interface PlantMyConfigInput {
  meterInversion?: boolean;
}
export interface devicesBodyRes {
  ack?: string;
  analysisResult?: string;
  content?: string;
  createTime?: string;
  deviceSN?: string;
  orderId?: string;
  success?: boolean;
  updateTime?: string;
}
export interface Interval {
  from: number;
  to: number;
}
export interface PlantsUidHashMap {
  plantUid?: string;
  plantHash?: string;
}
export interface User {
  email: string;
  operator?: boolean;
  userLevel?: number;
}
export interface PlantConflictInput {
  conflictId?: string;
}

export type EvChRTData = EvChRTV2 | AHEvChRT;

export type ActionLog = ActionRes | ActionCMD;

export type EvChData = EvChRT | EvChSESSION | EvChDAY | EvChMONTH;

export type EvChDataV2 = EvChDAYV2 | AHEvChDAY;

export type HeatPumpRTData = AHheatPumpRTData;

export type HeatPumpDAY = AHheatPumpDAY;

export type ConnextDevice = EvChType | inverterType;

export type DeviceHistoryTypeRange = ConnextUser | ConnextIO | EvChType | inverterType | ConnextConfig | ConnextSN | ConnextName | ConnextFw | ConnextHwV | ConnextDef | ConnextConnection | ConnextCellInfo;

export type LoggerDataType = ConnextDataType | SolarmanDataType | AzzurroHubDataType;

export type EmsStateType = ConnextDataType | AzzurroHubDataType;

export type AzzurroUserIdentityType = Operator | ServicePartnerCertification | BaseCertificationInstaller | AdvanceCertificationInstaller;

export type InverterData = Inverter | InverterDay | InverterMonth;

export type AzzurroHubDeviceType = AHinverterType | AHmeterType | AHevChargerCANType | AHevCharger485Type | AHpowerMagicType | AHsolarSensorType | AHpsc100Type;


export enum LoggerEnumType {
  Azzurro_Hub = 'Azzurro_Hub',
  Solarman = 'Solarman',
  Connext = 'Connext',
  Meter = 'Meter',
  Combox = 'Combox',
}
export enum Series {
  DAY = 'DAY',
  MONTH = 'MONTH',
}
export enum EvchST {
  START = 'START',
  FAULT = 'FAULT',
  IDLE = 'IDLE',
  CHARGING = 'CHARGING',
  CHARGING_NO_PWR = 'CHARGING_NO_PWR',
  PARKING = 'PARKING',
  FINISH = 'FINISH',
  ERROR = 'ERROR',
  PAUSED = 'PAUSED',
}
export enum EvchPP {
  EVC_ST_FAST = 'EVC_ST_FAST',
  EVC_ST_GREEN = 'EVC_ST_GREEN',
  EVC_ST_KM_REPEAT = 'EVC_ST_KM_REPEAT',
  EVC_ST_GREEN_MIXED = 'EVC_ST_GREEN_MIXED',
  EVC_ST_KM_SINGLE = 'EVC_ST_KM_SINGLE',
  EVC_ST_TIME_PWR = 'EVC_ST_TIME_PWR',
  EVC_ST_TIME_PWR_SINGLE = 'EVC_ST_TIME_PWR_SINGLE',
  EVC_ST_0_IMMISSION = 'EVC_ST_0_IMMISSION',
  EVC_ST_LAST = 'EVC_ST_LAST',
}
export enum AHevchStrategyEnum {
  green = 'green',
  fast = 'fast',
}
export enum AHdeviceTypeEnum {
  inverter = 'inverter',
  meter = 'meter',
  evChargerCAN = 'evChargerCAN',
  evCharger485 = 'evCharger485',
  pwrMagic = 'pwrMagic',
  heatPump = 'heatPump',
  solarSensor = 'solarSensor',
  PSC100 = 'PSC100',
}
export enum AHcurrOpModeEnum {
  None = 'None',
  Cooling = 'Cooling',
  Heating = 'Heating',
  Auto = 'Auto',
  HotWater = 'HotWater',
}
export enum AHglobStatusEnum {
  Standby = 'Standby',
  Starting = 'Starting',
  Running = 'Running',
  Shutdown = 'Shutdown',
  Alarm = 'Alarm',
}
export enum AHclimOpModeEnum {
  Heating = 'Heating',
  Cooling = 'Cooling',
  Automatic = 'Automatic',
}
export enum FwBuild {
  DEBUG = 'DEBUG',
  RELEASE = 'RELEASE',
  ANY = 'ANY',
}
export enum AHactPwrCtrlAlgoEnum {
  sumPhases = 'sumPhases',
  bestPhases = 'bestPhases',
}
export enum AHintSensorInversionEnum {
  none = 'none',
  grid = 'grid',
  prod = 'prod',
  both = 'both',
}
export enum AHmonitoringModeEnum {
  invMaster = 'invMaster',
  meter = 'meter',
  intSensor = 'intSensor',
  none = 'none',
  pwrMagic = 'pwrMagic',
}
export enum AHplantPhasesEnum {
  monoPhase = 'monoPhase',
  threePhase = 'threePhase',
}
export enum AHscanDevicesEnum {
  idle = 'idle',
  inProgress = 'inProgress',
}
export enum AHoperationalEnum {
  busy = 'busy',
  normal = 'normal',
}
export enum AHplantDetectEnum {
  hyd = 'hyd',
  importExport = 'importExport',
  solar = 'solar',
}
export enum AHmodelTypeEnum {
  MONO_PHASE = 'MONO_PHASE',
  THREE_PHASE_3W = 'THREE_PHASE_3W',
  THREE_PHASE_4W = 'THREE_PHASE_4W',
}
export enum AHsts {
  FAULT = 'FAULT',
  IDLE = 'IDLE',
  CHARGING = 'CHARGING',
  CHARGING_NO_PWR = 'CHARGING_NO_PWR',
  PARKING = 'PARKING',
  FINISH = 'FINISH',
  ERROR = 'ERROR',
  PAUSED = 'PAUSED',
}
export enum AHcurrBootSlotEnum {
  A = 'A',
  B = 'B',
}
export enum AHbootStsEnum {
  Normal = 'Normal',
  Test = 'Test',
  Verify = 'Verify',
}
export enum AHethStatusEnum {
  up = 'up',
  down = 'down',
}
export enum AHwifiStatusEnum {
  up = 'up',
  down = 'down',
}
export enum PlantDeviceEnumType {
  INVERTER = 'INVERTER',
  METER = 'METER',
  EVCH = 'EVCH',
  SENSOR = 'SENSOR',
  COMBOX = 'COMBOX',
}
export enum PlantEmsEnumType {
  CONNEXT = 'CONNEXT',
  AZZURRO_HUB = 'AZZURRO_HUB',
}
export enum PhaseEnumType {
  monoPhase = 'monoPhase',
  threePhase = 'threePhase',
}
export enum PlantMonitoringEnumType {
  CONNEXT = 'CONNEXT',
  SOLARMAN = 'SOLARMAN',
  CONNEXT_SOLARMAN = 'CONNEXT_SOLARMAN',
  AZZURRO_HUB = 'AZZURRO_HUB',
  AZZURRO_HUB_SOLARMAN = 'AZZURRO_HUB_SOLARMAN',
}
export enum MonitorPrefEnumType {
  CONNEXT = 'CONNEXT',
  SOLARMAN = 'SOLARMAN',
  AZZURRO_HUB = 'AZZURRO_HUB',
}
export enum GenerationEnum {
  G1_ZCS = 'G1_ZCS',
  G2_ZCS = 'G2_ZCS',
  G3_ZCS = 'G3_ZCS',
  GPM_ZCS = 'GPM_ZCS',
}
export enum EventModel {
  AcCurrentUnbalanceFault = 'AcCurrentUnbalanceFault',
  AcHardwareOvercurrentFault = 'AcHardwareOvercurrentFault',
  BatteryLow = 'BatteryLow',
  BatteryLowVoltageShutdown = 'BatteryLowVoltageShutdown',
  BMS1CommunicatonFault = 'BMS1CommunicatonFault',
  BMS2CommunicatonFault = 'BMS2CommunicatonFault',
  BMSOvervoltageProtection = 'BMSOvervoltageProtection',
  BMSUndervoltageProtection = 'BMSUndervoltageProtection',
  BMSVerFault = 'BMSVerFault',
  ZBTS5kSleepMode = 'ZBTS5kSleepMode',
  BusHardwareOvervoltageFault = 'BusHardwareOvervoltageFault',
  BusOvervoltageFault = 'BusOvervoltageFault',
  BusUnbalanceFault = 'BusUnbalanceFault',
  CTError = 'CTError',
  EpsBatteryOvercurrentFault = 'EpsBatteryOvercurrentFault',
  Fan1Failure = 'Fan1Failure',
  Fan2Failure = 'Fan2Failure',
  Fan3Failure = 'Fan3Failure',
  Fan4Failure = 'Fan4Failure',
  Fan5Failure = 'Fan5Failure',
  Fan6Failure = 'Fan6Failure',
  Fan7Failure = 'Fan7Failure',
  GridOverfrequency = 'GridOverfrequency',
  GridOvervoltage = 'GridOvervoltage',
  GridUnderfrequency = 'GridUnderfrequency',
  GridUndervoltage = 'GridUndervoltage',
  InconsistentSoftwareVersion = 'InconsistentSoftwareVersion',
  InputModeSettingFailure = 'InputModeSettingFailure',
  InputOvercurrentFault = 'InputOvercurrentFault',
  InverterSoftStartFailure = 'InverterSoftStartFailure',
  IslandingError = 'IslandingError',
  LeakageCurrentFault = 'LeakageCurrentFault',
  LowInsulationResistance = 'LowInsulationResistance',
  MeterError = 'MeterError',
  OutputInstantaneousOvercurrentFault = 'OutputInstantaneousOvercurrentFault',
  PVOvervoltage = 'PVOvervoltage',
  PvUnevenCurrentFault = 'PvUnevenCurrentFault',
  RelayDetectionFailure = 'RelayDetectionFailure',
  RelayUnbalancedPermanentFailure = 'RelayUnbalancedPermanentFailure',
  SCIError_AC = 'SCIError_AC',
  SCIError_DC = 'SCIError_DC',
  SCIError_Fuse = 'SCIError_Fuse',
  SPICommError_AC = 'SPICommError_AC',
  SPICommError_DC = 'SPICommError_DC',
  SafetyVerFault = 'SafetyVerFault',
  WeakBattery = 'WeakBattery',
  GPMError = 'GPMError',
  GPMWarning = 'GPMWarning',
  GPMNotice = 'GPMNotice',
}
export enum Channel {
  Solarman = 'Solarman',
  Azzurro_MQTT = 'Azzurro_MQTT',
  Azzurro_Ethernet = 'Azzurro_Ethernet',
}
export enum Operation {
  MODBUS = 'MODBUS',
  AGGIORNAMENTO = 'AGGIORNAMENTO',
  AGGIORNAMENTO_LOGGER = 'AGGIORNAMENTO_LOGGER',
}
export enum RDSDeviceTypeEnum {
  INVERTER = 'INVERTER',
  EVCH = 'EVCH',
  COMBOX = 'COMBOX',
  SENSOR = 'SENSOR',
}
export enum BatteryModelEnum {
  BMS_DEFAULT = 'BMS_DEFAULT',
  PYLON = 'PYLON',
  GENERAL = 'GENERAL',
  AMASS = 'AMASS',
  LG = 'LG',
  ALPHA_ESS = 'ALPHA_ESS',
  CATL = 'CATL',
  WECO = 'WECO',
  FRONIUS = 'FRONIUS',
  EMS = 'EMS',
  NILAR = 'NILAR',
  BTS_5K = 'BTS_5K',
  STRONG_C = 'STRONG_C',
  NEOOM = 'NEOOM',
}
export enum RDSDeviceSortEnum {
  updatedAt = 'updatedAt',
  createdAt = 'createdAt',
}
export enum RDSSortDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum RDSAlertsStatusEnum {
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
}
export enum RDSGenerationEnum {
  G1 = 'G1',
  G2 = 'G2',
  G3 = 'G3',
}
export enum RDSAlertsSortEnum {
  updatedAt = 'updatedAt',
  createdAt = 'createdAt',
}
export enum RDSEventModel {
  BatteryLow = 'BatteryLow',
  BMSBlock = 'BMSBlock',
  WeakBattery = 'WeakBattery',
  ZBTS5kSleepMode = 'ZBTS5kSleepMode',
}
export enum RDSAzzurroEventsEnum {
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
}
export enum RDSAzzurroEventsSortEnum {
  updatedAt = 'updatedAt',
  createdAt = 'createdAt',
}
export enum IdentityInput {
  Operator = 'Operator',
  ServicePartnerCertification = 'ServicePartnerCertification',
  BaseCertificationInstaller = 'BaseCertificationInstaller',
  AdvanceCertificationInstaller = 'AdvanceCertificationInstaller',
}
export enum ErrorType {
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
}
export enum EventsOperation {
  update = 'update',
  set = 'set',
  delete = 'delete',
}
export enum AzzurroHubAction {
  changeDeviceStatus = 'changeDeviceStatus',
  changeLoggerConfig = 'changeLoggerConfig',
  changePlantConfig = 'changePlantConfig',
  changeHeatPumpConfig = 'changeHeatPumpConfig',
  changeVirtualRTStatus = 'changeVirtualRTStatus',
  modbusStr = 'modbusStr',
  deviceUpgrade = 'deviceUpgrade',
  changeNetStatus = 'changeNetStatus',
}
export enum AzzurroHubOperation {
  rescan = 'rescan',
}
export enum ActPwrCtrlAlgoInput {
  bestPhases = 'bestPhases',
  sumPhases = 'sumPhases',
}
export enum IntSensorInversionInput {
  both = 'both',
  grid = 'grid',
  none = 'none',
  prod = 'prod',
}
export enum MonitoringModeInput {
  intSensor = 'intSensor',
  invMaster = 'invMaster',
  meter = 'meter',
  none = 'none',
  pwrMagic = 'pwrMagic',
}
export enum PlantPhasesInput {
  monoPhase = 'monoPhase',
  threePhase = 'threePhase',
}
export enum EvchStrategyInput {
  green = 'green',
  fast = 'fast',
}
export enum VirtualRTAzzurroHubTarget {
  ZZ = 'ZZ',
}
export enum VirtualRTAzzurroHubAction {
  startVirtualRT = 'startVirtualRT',
  stopVirtualRT = 'stopVirtualRT',
}
export enum PlantStatusEnumType {
  MERGED = 'MERGED',
  CONFLICTING = 'CONFLICTING',
  VERIFIED = 'VERIFIED',
}
export enum connextDataLevel {
  ALL = 'ALL',
  STATUS = 'STATUS',
  USERS = 'USERS',
  INFO = 'INFO',
  CONFIG = 'CONFIG',
  DEVICES = 'DEVICES',
}
export enum ConnextStatus {
  CREATED = 'CREATED',
  PROVISIONED = 'PROVISIONED',
  ACTIVATED = 'ACTIVATED',
  DEACTIVATED = 'DEACTIVATED',
}


export const serializeRange = (input: Range) => {
  const MISSING = 'MISSING';
  const parts = [
    input.from !== undefined ? `from: ${JSON.stringify(input.from)}` : MISSING,
    input.to !== undefined ? `to: ${JSON.stringify(input.to)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializePage = (input: Page) => {
  const MISSING = 'MISSING';
  const parts = [
    input.nextToken !== undefined ? `nextToken: ${JSON.stringify(input.nextToken)}` : MISSING,
    input.limit !== undefined ? `limit: ${JSON.stringify(input.limit)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeRDSDevicesStatusInput = (input: RDSDevicesStatusInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.filter !== undefined ? `filter: ${serializeRDSDevicesStatusFilter(input.filter)}` : MISSING,
    input.pagination !== undefined ? `pagination: ${serializeRDSPaginationInput(input.pagination)}` : MISSING,
    input.sort !== undefined ? `sort: ${serializeRDSDevicesSortInput(input.sort)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeRDSDevicesStatusFilter = (input: RDSDevicesStatusFilter) => {
  const MISSING = 'MISSING';
  const parts = [
    input.deviceId !== undefined ? `deviceId: ${JSON.stringify(input.deviceId)}` : MISSING,
    input.isInAlarm !== undefined ? `isInAlarm: ${JSON.stringify(input.isInAlarm)}` : MISSING,
    input.type !== undefined ? `type: ${input.type}` : MISSING,
    input.batteryModel !== undefined ? `batteryModel: ${input.batteryModel}` : MISSING,
    input.arm !== undefined ? `arm: ${JSON.stringify(input.arm)}` : MISSING,
    input.dspm !== undefined ? `dspm: ${JSON.stringify(input.dspm)}` : MISSING,
    input.dsps !== undefined ? `dsps: ${JSON.stringify(input.dsps)}` : MISSING,
    input.hasAzzurroEvents !== undefined ? `hasAzzurroEvents: ${JSON.stringify(input.hasAzzurroEvents)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeRDSPaginationInput = (input: RDSPaginationInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.pageSize !== undefined ? `pageSize: ${JSON.stringify(input.pageSize)}` : MISSING,
    input.pageIndex !== undefined ? `pageIndex: ${JSON.stringify(input.pageIndex)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeRDSDevicesSortInput = (input: RDSDevicesSortInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.column !== undefined ? `column: ${input.column}` : MISSING,
    input.sortDirection !== undefined ? `sortDirection: ${input.sortDirection}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeRDSAlertsStatusInput = (input: RDSAlertsStatusInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.filter !== undefined ? `filter: ${serializeRDSAlertsStatusFilter(input.filter)}` : MISSING,
    input.pagination !== undefined ? `pagination: ${serializeRDSPaginationInput(input.pagination)}` : MISSING,
    input.sort !== undefined ? `sort: ${serializeRDSAlertsSortInput(input.sort)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeRDSAlertsStatusFilter = (input: RDSAlertsStatusFilter) => {
  const MISSING = 'MISSING';
  const parts = [
    input.alertIdByGeneration !== undefined ? `alertIdByGeneration: ${serializeRDSAlertByGenerationInput(input.alertIdByGeneration)}` : MISSING,
    input.arm !== undefined ? `arm: ${JSON.stringify(input.arm)}` : MISSING,
    input.dspm !== undefined ? `dspm: ${JSON.stringify(input.dspm)}` : MISSING,
    input.dsps !== undefined ? `dsps: ${JSON.stringify(input.dsps)}` : MISSING,
    input.deviceId !== undefined ? `deviceId: ${JSON.stringify(input.deviceId)}` : MISSING,
    input.batteryModel !== undefined ? `batteryModel: ${input.batteryModel}` : MISSING,
    input.status !== undefined ? `status: ${input.status}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeRDSAlertByGenerationInput = (input: RDSAlertByGenerationInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.alertId !== undefined ? `alertId: ${JSON.stringify(input.alertId)}` : MISSING,
    input.generation !== undefined ? `generation: ${input.generation}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeRDSAlertsSortInput = (input: RDSAlertsSortInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.column !== undefined ? `column: ${input.column}` : MISSING,
    input.sortDirection !== undefined ? `sortDirection: ${input.sortDirection}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeRDSAzzurroEventsInput = (input: RDSAzzurroEventsInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.filter !== undefined ? `filter: ${serializeRDSAzzurroEventsFilter(input.filter)}` : MISSING,
    input.pagination !== undefined ? `pagination: ${serializeRDSPaginationInput(input.pagination)}` : MISSING,
    input.sort !== undefined ? `sort: ${serializeRDSAzzurroEventsSortInput(input.sort)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeRDSAzzurroEventsFilter = (input: RDSAzzurroEventsFilter) => {
  const MISSING = 'MISSING';
  const parts = [
    input.azzurroEvent !== undefined ? `azzurroEvent: ${input.azzurroEvent}` : MISSING,
    input.arm !== undefined ? `arm: ${JSON.stringify(input.arm)}` : MISSING,
    input.dspm !== undefined ? `dspm: ${JSON.stringify(input.dspm)}` : MISSING,
    input.dsps !== undefined ? `dsps: ${JSON.stringify(input.dsps)}` : MISSING,
    input.deviceId !== undefined ? `deviceId: ${JSON.stringify(input.deviceId)}` : MISSING,
    input.batteryModel !== undefined ? `batteryModel: ${input.batteryModel}` : MISSING,
    input.status !== undefined ? `status: ${input.status}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeRDSAzzurroEventsSortInput = (input: RDSAzzurroEventsSortInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.column !== undefined ? `column: ${input.column}` : MISSING,
    input.sortDirection !== undefined ? `sortDirection: ${input.sortDirection}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeactionCMD = (input: actionCMD) => {
  const MISSING = 'MISSING';
  const parts = [
    input.args !== undefined ? `args: ${input.args?.map((item) => JSON.stringify(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.cmd !== undefined ? `cmd: ${JSON.stringify(input.cmd)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeactionRes = (input: actionRes) => {
  const MISSING = 'MISSING';
  const parts = [
    input.msg !== undefined ? `msg: ${JSON.stringify(input.msg)}` : MISSING,
    input.success !== undefined ? `success: ${JSON.stringify(input.success)}` : MISSING,
    input.msgCode !== undefined ? `msgCode: ${JSON.stringify(input.msgCode)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeModbusCommandLog = (input: ModbusCommandLog) => {
  const MISSING = 'MISSING';
  const parts = [
    input.deviceId !== undefined ? `deviceId: ${JSON.stringify(input.deviceId)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.request !== undefined ? `request: ${JSON.stringify(input.request)}` : MISSING,
    input.response !== undefined ? `response: ${JSON.stringify(input.response)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeUpdatePlantStatusInput = (input: UpdatePlantStatusInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.email !== undefined ? `email: ${input.email?.map((item) => JSON.stringify(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.changesPath !== undefined ? `changesPath: ${input.changesPath?.map((item) => JSON.stringify(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.operationType !== undefined ? `operationType: ${JSON.stringify(input.operationType)}` : MISSING,
    input.plant !== undefined ? `plant: ${input.plant?.map((item) => serializeMyCertifiedPlantInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeMyCertifiedPlantInput = (input: MyCertifiedPlantInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.plantId !== undefined ? `plantId: ${JSON.stringify(input.plantId)}` : MISSING,
    input.devices !== undefined ? `devices: ${input.devices?.map((item) => serializePlantDeviceInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.ems !== undefined ? `ems: ${input.ems?.map((item) => serializePlantEmsInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.loggers !== undefined ? `loggers: ${input.loggers?.map((item) => serializeSolarmanDataInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.ems_state !== undefined ? `ems_state: ${input.ems_state?.map((item) => serializeConnextDataInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.ems_state_v2 !== undefined ? `ems_state_v2: ${input.ems_state_v2?.map((item) => serializeEmsStateInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.users !== undefined ? `users: ${input.users?.map((item) => serializePlantMyUserInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.geo !== undefined ? `geo: ${serializePlantGeoInput(input.geo)}` : MISSING,
    input.config !== undefined ? `config: ${serializePlantConfigInput(input.config)}` : MISSING,
    input.plantPref !== undefined ? `plantPref: ${serializePlantPrefInput(input.plantPref)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializePlantDeviceInput = (input: PlantDeviceInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.type !== undefined ? `type: ${input.type}` : MISSING,
    input.installationTime !== undefined ? `installationTime: ${JSON.stringify(input.installationTime)}` : MISSING,
    input.disinstallationTime !== undefined ? `disinstallationTime: ${JSON.stringify(input.disinstallationTime)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializePlantEmsInput = (input: PlantEmsInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.type !== undefined ? `type: ${input.type}` : MISSING,
    input.installationTime !== undefined ? `installationTime: ${JSON.stringify(input.installationTime)}` : MISSING,
    input.disinstallationTime !== undefined ? `disinstallationTime: ${JSON.stringify(input.disinstallationTime)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSolarmanDataInput = (input: SolarmanDataInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.loggerId !== undefined ? `loggerId: ${JSON.stringify(input.loggerId)}` : MISSING,
    input.info !== undefined ? `info: ${serializeSolarmanInfoInput(input.info)}` : MISSING,
    input.devices !== undefined ? `devices: ${input.devices?.map((item) => serializeSolarmanDeviceInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.inverter !== undefined ? `inverter: ${input.inverter?.map((item) => serializeSolarmanInverterInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.lan !== undefined ? `lan: ${serializeSolarmanLanInput(input.lan)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSolarmanInfoInput = (input: SolarmanInfoInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.name !== undefined ? `name: ${serializeSolarmanNameInput(input.name)}` : MISSING,
    input.fw !== undefined ? `fw: ${serializeSolarmanFwInput(input.fw)}` : MISSING,
    input.hwv !== undefined ? `hwv: ${serializeSolarmanHwVInput(input.hwv)}` : MISSING,
    input.def !== undefined ? `def: ${serializeSolarmanDefInput(input.def)}` : MISSING,
    input.connection !== undefined ? `connection: ${serializeSolarmanConnectionInput(input.connection)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSolarmanNameInput = (input: SolarmanNameInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.name !== undefined ? `name: ${JSON.stringify(input.name)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSolarmanFwInput = (input: SolarmanFwInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.cfgFileName !== undefined ? `cfgFileName: ${JSON.stringify(input.cfgFileName)}` : MISSING,
    input.cfgFileVer !== undefined ? `cfgFileVer: ${JSON.stringify(input.cfgFileVer)}` : MISSING,
    input.firmwareVer !== undefined ? `firmwareVer: ${JSON.stringify(input.firmwareVer)}` : MISSING,
    input.hardwareVer !== undefined ? `hardwareVer: ${JSON.stringify(input.hardwareVer)}` : MISSING,
    input.manufacturer !== undefined ? `manufacturer: ${JSON.stringify(input.manufacturer)}` : MISSING,
    input.model !== undefined ? `model: ${JSON.stringify(input.model)}` : MISSING,
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSolarmanHwVInput = (input: SolarmanHwVInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.hwVer !== undefined ? `hwVer: ${JSON.stringify(input.hwVer)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSolarmanDefInput = (input: SolarmanDefInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.thingDef !== undefined ? `thingDef: ${JSON.stringify(input.thingDef)}` : MISSING,
    input.type !== undefined ? `type: ${JSON.stringify(input.type)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSolarmanConnectionInput = (input: SolarmanConnectionInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.status !== undefined ? `status: ${JSON.stringify(input.status)}` : MISSING,
    input.disconnectReason !== undefined ? `disconnectReason: ${JSON.stringify(input.disconnectReason)}` : MISSING,
    input.ipAddress !== undefined ? `ipAddress: ${JSON.stringify(input.ipAddress)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSolarmanDeviceInput = (input: SolarmanDeviceInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.arm !== undefined ? `arm: ${JSON.stringify(input.arm)}` : MISSING,
    input.dspm !== undefined ? `dspm: ${JSON.stringify(input.dspm)}` : MISSING,
    input.dsps !== undefined ? `dsps: ${JSON.stringify(input.dsps)}` : MISSING,
    input.created !== undefined ? `created: ${JSON.stringify(input.created)}` : MISSING,
    input.lastUpdate !== undefined ? `lastUpdate: ${JSON.stringify(input.lastUpdate)}` : MISSING,
    input.fota_module !== undefined ? `fota_module: ${JSON.stringify(input.fota_module)}` : MISSING,
    input.fota_status !== undefined ? `fota_status: ${JSON.stringify(input.fota_status)}` : MISSING,
    input.updating !== undefined ? `updating: ${JSON.stringify(input.updating)}` : MISSING,
    input.upd_global !== undefined ? `upd_global: ${serializeModuleUpdateInput(input.upd_global)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeModuleUpdateInput = (input: ModuleUpdateInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.status !== undefined ? `status: ${JSON.stringify(input.status)}` : MISSING,
    input.progress !== undefined ? `progress: ${JSON.stringify(input.progress)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSolarmanInverterInput = (input: SolarmanInverterInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.arm !== undefined ? `arm: ${JSON.stringify(input.arm)}` : MISSING,
    input.dspm !== undefined ? `dspm: ${JSON.stringify(input.dspm)}` : MISSING,
    input.dsps !== undefined ? `dsps: ${JSON.stringify(input.dsps)}` : MISSING,
    input.created !== undefined ? `created: ${JSON.stringify(input.created)}` : MISSING,
    input.lastUpdate !== undefined ? `lastUpdate: ${JSON.stringify(input.lastUpdate)}` : MISSING,
    input.fota_module !== undefined ? `fota_module: ${JSON.stringify(input.fota_module)}` : MISSING,
    input.fota_status !== undefined ? `fota_status: ${JSON.stringify(input.fota_status)}` : MISSING,
    input.updating !== undefined ? `updating: ${JSON.stringify(input.updating)}` : MISSING,
    input.upd_global !== undefined ? `upd_global: ${serializeModuleUpdateInput(input.upd_global)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSolarmanLanInput = (input: SolarmanLanInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.lte_IMEI !== undefined ? `lte_IMEI: ${JSON.stringify(input.lte_IMEI)}` : MISSING,
    input.lte_IMSI !== undefined ? `lte_IMSI: ${JSON.stringify(input.lte_IMSI)}` : MISSING,
    input.lte_apnServer !== undefined ? `lte_apnServer: ${JSON.stringify(input.lte_apnServer)}` : MISSING,
    input.lte_apnUser !== undefined ? `lte_apnUser: ${JSON.stringify(input.lte_apnUser)}` : MISSING,
    input.lte_apnPsw !== undefined ? `lte_apnPsw: ${JSON.stringify(input.lte_apnPsw)}` : MISSING,
    input.lte_ICCID !== undefined ? `lte_ICCID: ${JSON.stringify(input.lte_ICCID)}` : MISSING,
    input.lte_strength !== undefined ? `lte_strength: ${JSON.stringify(input.lte_strength)}` : MISSING,
    input.wifi_SSID !== undefined ? `wifi_SSID: ${JSON.stringify(input.wifi_SSID)}` : MISSING,
    input.wifi_ip !== undefined ? `wifi_ip: ${JSON.stringify(input.wifi_ip)}` : MISSING,
    input.wifi_routerIP !== undefined ? `wifi_routerIP: ${JSON.stringify(input.wifi_routerIP)}` : MISSING,
    input.wifi_DNS !== undefined ? `wifi_DNS: ${JSON.stringify(input.wifi_DNS)}` : MISSING,
    input.wifi_status !== undefined ? `wifi_status: ${JSON.stringify(input.wifi_status)}` : MISSING,
    input.wifi_enabled !== undefined ? `wifi_enabled: ${JSON.stringify(input.wifi_enabled)}` : MISSING,
    input.wifi_online !== undefined ? `wifi_online: ${JSON.stringify(input.wifi_online)}` : MISSING,
    input.wifi_psw !== undefined ? `wifi_psw: ${JSON.stringify(input.wifi_psw)}` : MISSING,
    input.eth_ip !== undefined ? `eth_ip: ${JSON.stringify(input.eth_ip)}` : MISSING,
    input.eth_routerIP !== undefined ? `eth_routerIP: ${JSON.stringify(input.eth_routerIP)}` : MISSING,
    input.eth_DNS !== undefined ? `eth_DNS: ${JSON.stringify(input.eth_DNS)}` : MISSING,
    input.eth_status !== undefined ? `eth_status: ${JSON.stringify(input.eth_status)}` : MISSING,
    input.eth_enabled !== undefined ? `eth_enabled: ${JSON.stringify(input.eth_enabled)}` : MISSING,
    input.eth_online !== undefined ? `eth_online: ${JSON.stringify(input.eth_online)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeConnextDataInput = (input: ConnextDataInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.loggerId !== undefined ? `loggerId: ${JSON.stringify(input.loggerId)}` : MISSING,
    input.info !== undefined ? `info: ${serializeConnextInfoInput(input.info)}` : MISSING,
    input.devices !== undefined ? `devices: ${input.devices?.map((item) => serializeConnextInverterInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.evch !== undefined ? `evch: ${input.evch?.map((item) => serializeConnextEvChInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.io !== undefined ? `io: ${input.io?.map((item) => serializeConnextIOInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.config !== undefined ? `config: ${serializeConnextConfigInput(input.config)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeConnextInfoInput = (input: ConnextInfoInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.sn !== undefined ? `sn: ${serializeConnextSNInput(input.sn)}` : MISSING,
    input.name !== undefined ? `name: ${serializeConnextNameInput(input.name)}` : MISSING,
    input.fw !== undefined ? `fw: ${serializeConnextFwInput(input.fw)}` : MISSING,
    input.hwv !== undefined ? `hwv: ${serializeConnextHwVInput(input.hwv)}` : MISSING,
    input.def !== undefined ? `def: ${serializeConnextDefInput(input.def)}` : MISSING,
    input.connection !== undefined ? `connection: ${serializeConnextConnectionInput(input.connection)}` : MISSING,
    input.cell_info !== undefined ? `cell_info: ${serializeConnextCellInfoInput(input.cell_info)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeConnextSNInput = (input: ConnextSNInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.uid !== undefined ? `uid: ${JSON.stringify(input.uid)}` : MISSING,
    input.type !== undefined ? `type: ${JSON.stringify(input.type)}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeConnextNameInput = (input: ConnextNameInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.name !== undefined ? `name: ${JSON.stringify(input.name)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeConnextFwInput = (input: ConnextFwInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.fota_status !== undefined ? `fota_status: ${JSON.stringify(input.fota_status)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.type !== undefined ? `type: ${JSON.stringify(input.type)}` : MISSING,
    input.fw_ver !== undefined ? `fw_ver: ${JSON.stringify(input.fw_ver)}` : MISSING,
    input.fwCategory !== undefined ? `fwCategory: ${JSON.stringify(input.fwCategory)}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeConnextHwVInput = (input: ConnextHwVInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.hwVer !== undefined ? `hwVer: ${JSON.stringify(input.hwVer)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeConnextDefInput = (input: ConnextDefInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.thingDef !== undefined ? `thingDef: ${JSON.stringify(input.thingDef)}` : MISSING,
    input.type !== undefined ? `type: ${JSON.stringify(input.type)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeConnextConnectionInput = (input: ConnextConnectionInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.status !== undefined ? `status: ${JSON.stringify(input.status)}` : MISSING,
    input.disconnectReason !== undefined ? `disconnectReason: ${JSON.stringify(input.disconnectReason)}` : MISSING,
    input.ipAddress !== undefined ? `ipAddress: ${JSON.stringify(input.ipAddress)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeConnextCellInfoInput = (input: ConnextCellInfoInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.imei !== undefined ? `imei: ${JSON.stringify(input.imei)}` : MISSING,
    input.cell_model !== undefined ? `cell_model: ${JSON.stringify(input.cell_model)}` : MISSING,
    input.icc_id !== undefined ? `icc_id: ${JSON.stringify(input.icc_id)}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.cell_revision !== undefined ? `cell_revision: ${JSON.stringify(input.cell_revision)}` : MISSING,
    input.cell_serial !== undefined ? `cell_serial: ${JSON.stringify(input.cell_serial)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeConnextInverterInput = (input: ConnextInverterInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.type !== undefined ? `type: ${JSON.stringify(input.type)}` : MISSING,
    input.model !== undefined ? `model: ${JSON.stringify(input.model)}` : MISSING,
    input.cmd !== undefined ? `cmd: ${JSON.stringify(input.cmd)}` : MISSING,
    input.dModel !== undefined ? `dModel: ${JSON.stringify(input.dModel)}` : MISSING,
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.active !== undefined ? `active: ${JSON.stringify(input.active)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.id !== undefined ? `id: ${JSON.stringify(input.id)}` : MISSING,
    input.id_list !== undefined ? `id_list: ${JSON.stringify(input.id_list)}` : MISSING,
    input.modbus_address !== undefined ? `modbus_address: ${JSON.stringify(input.modbus_address)}` : MISSING,
    input.d2evc !== undefined ? `d2evc: ${JSON.stringify(input.d2evc)}` : MISSING,
    input.threeF !== undefined ? `threeF: ${JSON.stringify(input.threeF)}` : MISSING,
    input.version !== undefined ? `version: ${JSON.stringify(input.version)}` : MISSING,
    input.thingDef !== undefined ? `thingDef: ${JSON.stringify(input.thingDef)}` : MISSING,
    input.sensor_mode !== undefined ? `sensor_mode: ${JSON.stringify(input.sensor_mode)}` : MISSING,
    input.registered !== undefined ? `registered: ${JSON.stringify(input.registered)}` : MISSING,
    input.rgistered !== undefined ? `rgistered: ${JSON.stringify(input.rgistered)}` : MISSING,
    input.k !== undefined ? `k: ${JSON.stringify(input.k)}` : MISSING,
    input.dsps !== undefined ? `dsps: ${JSON.stringify(input.dsps)}` : MISSING,
    input.dspm !== undefined ? `dspm: ${JSON.stringify(input.dspm)}` : MISSING,
    input.arm !== undefined ? `arm: ${JSON.stringify(input.arm)}` : MISSING,
    input.fw_rev !== undefined ? `fw_rev: ${JSON.stringify(input.fw_rev)}` : MISSING,
    input.grid_meter !== undefined ? `grid_meter: ${JSON.stringify(input.grid_meter)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeConnextEvChInput = (input: ConnextEvChInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.type !== undefined ? `type: ${JSON.stringify(input.type)}` : MISSING,
    input.dModel !== undefined ? `dModel: ${JSON.stringify(input.dModel)}` : MISSING,
    input.model !== undefined ? `model: ${JSON.stringify(input.model)}` : MISSING,
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.active !== undefined ? `active: ${JSON.stringify(input.active)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.limitPower !== undefined ? `limitPower: ${JSON.stringify(input.limitPower)}` : MISSING,
    input.chargerMode !== undefined ? `chargerMode: ${JSON.stringify(input.chargerMode)}` : MISSING,
    input.carConsumption !== undefined ? `carConsumption: ${JSON.stringify(input.carConsumption)}` : MISSING,
    input.fwVer !== undefined ? `fwVer: ${JSON.stringify(input.fwVer)}` : MISSING,
    input.startTime !== undefined ? `startTime: ${JSON.stringify(input.startTime)}` : MISSING,
    input.tStart !== undefined ? `tStart: ${JSON.stringify(input.tStart)}` : MISSING,
    input.tpDuration !== undefined ? `tpDuration: ${JSON.stringify(input.tpDuration)}` : MISSING,
    input.tpPower !== undefined ? `tpPower: ${JSON.stringify(input.tpPower)}` : MISSING,
    input.inputGreenPower !== undefined ? `inputGreenPower: ${JSON.stringify(input.inputGreenPower)}` : MISSING,
    input.status !== undefined ? `status: ${JSON.stringify(input.status)}` : MISSING,
    input.rsn !== undefined ? `rsn: ${JSON.stringify(input.rsn)}` : MISSING,
    input.maxpw !== undefined ? `maxpw: ${JSON.stringify(input.maxpw)}` : MISSING,
    input.st_cmd !== undefined ? `st_cmd: ${JSON.stringify(input.st_cmd)}` : MISSING,
    input.ready !== undefined ? `ready: ${JSON.stringify(input.ready)}` : MISSING,
    input.wb_err_id !== undefined ? `wb_err_id: ${JSON.stringify(input.wb_err_id)}` : MISSING,
    input.wb_err_ts !== undefined ? `wb_err_ts: ${JSON.stringify(input.wb_err_ts)}` : MISSING,
    input.error_id !== undefined ? `error_id: ${JSON.stringify(input.error_id)}` : MISSING,
    input.error_ts !== undefined ? `error_ts: ${JSON.stringify(input.error_ts)}` : MISSING,
    input.rt_exp !== undefined ? `rt_exp: ${JSON.stringify(input.rt_exp)}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeConnextIOInput = (input: ConnextIOInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.index !== undefined ? `index: ${JSON.stringify(input.index)}` : MISSING,
    input.active !== undefined ? `active: ${JSON.stringify(input.active)}` : MISSING,
    input.name !== undefined ? `name: ${JSON.stringify(input.name)}` : MISSING,
    input.out1 !== undefined ? `out1: ${JSON.stringify(input.out1)}` : MISSING,
    input.var1 !== undefined ? `var1: ${JSON.stringify(input.var1)}` : MISSING,
    input.thH !== undefined ? `thH: ${JSON.stringify(input.thH)}` : MISSING,
    input.thL !== undefined ? `thL: ${JSON.stringify(input.thL)}` : MISSING,
    input.time_th !== undefined ? `time_th: ${JSON.stringify(input.time_th)}` : MISSING,
    input.time_tl !== undefined ? `time_tl: ${JSON.stringify(input.time_tl)}` : MISSING,
    input.thH1 !== undefined ? `thH1: ${JSON.stringify(input.thH1)}` : MISSING,
    input.thL1 !== undefined ? `thL1: ${JSON.stringify(input.thL1)}` : MISSING,
    input.time_th1 !== undefined ? `time_th1: ${JSON.stringify(input.time_th1)}` : MISSING,
    input.time_tl1 !== undefined ? `time_tl1: ${JSON.stringify(input.time_tl1)}` : MISSING,
    input.t_min !== undefined ? `t_min: ${JSON.stringify(input.t_min)}` : MISSING,
    input.d_start !== undefined ? `d_start: ${JSON.stringify(input.d_start)}` : MISSING,
    input.d_stop !== undefined ? `d_stop: ${JSON.stringify(input.d_stop)}` : MISSING,
    input.t0_start !== undefined ? `t0_start: ${JSON.stringify(input.t0_start)}` : MISSING,
    input.t1_start !== undefined ? `t1_start: ${JSON.stringify(input.t1_start)}` : MISSING,
    input.t2_start !== undefined ? `t2_start: ${JSON.stringify(input.t2_start)}` : MISSING,
    input.t3_start !== undefined ? `t3_start: ${JSON.stringify(input.t3_start)}` : MISSING,
    input.t4_start !== undefined ? `t4_start: ${JSON.stringify(input.t4_start)}` : MISSING,
    input.t5_start !== undefined ? `t5_start: ${JSON.stringify(input.t5_start)}` : MISSING,
    input.t6_start !== undefined ? `t6_start: ${JSON.stringify(input.t6_start)}` : MISSING,
    input.t0_stop !== undefined ? `t0_stop: ${JSON.stringify(input.t0_stop)}` : MISSING,
    input.t1_stop !== undefined ? `t1_stop: ${JSON.stringify(input.t1_stop)}` : MISSING,
    input.t2_stop !== undefined ? `t2_stop: ${JSON.stringify(input.t2_stop)}` : MISSING,
    input.t3_stop !== undefined ? `t3_stop: ${JSON.stringify(input.t3_stop)}` : MISSING,
    input.t4_stop !== undefined ? `t4_stop: ${JSON.stringify(input.t4_stop)}` : MISSING,
    input.t5_stop !== undefined ? `t5_stop: ${JSON.stringify(input.t5_stop)}` : MISSING,
    input.t6_stop !== undefined ? `t6_stop: ${JSON.stringify(input.t6_stop)}` : MISSING,
    input.n_out !== undefined ? `n_out: ${JSON.stringify(input.n_out)}` : MISSING,
    input.level !== undefined ? `level: ${JSON.stringify(input.level)}` : MISSING,
    input.function !== undefined ? `function: ${JSON.stringify(input.function)}` : MISSING,
    input.out_state !== undefined ? `out_state: ${JSON.stringify(input.out_state)}` : MISSING,
    input.description !== undefined ? `description: ${JSON.stringify(input.description)}` : MISSING,
    input.src !== undefined ? `src: ${JSON.stringify(input.src)}` : MISSING,
    input.templateId !== undefined ? `templateId: ${JSON.stringify(input.templateId)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeConnextConfigInput = (input: ConnextConfigInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.maxLoadPwr !== undefined ? `maxLoadPwr: ${JSON.stringify(input.maxLoadPwr)}` : MISSING,
    input.plantCurrSensO !== undefined ? `plantCurrSensO: ${JSON.stringify(input.plantCurrSensO)}` : MISSING,
    input.plantCurrSensTR !== undefined ? `plantCurrSensTR: ${JSON.stringify(input.plantCurrSensTR)}` : MISSING,
    input.invCurrSensO !== undefined ? `invCurrSensO: ${JSON.stringify(input.invCurrSensO)}` : MISSING,
    input.invCurrSensTR !== undefined ? `invCurrSensTR: ${JSON.stringify(input.invCurrSensTR)}` : MISSING,
    input.TZ !== undefined ? `TZ: ${JSON.stringify(input.TZ)}` : MISSING,
    input.latitude !== undefined ? `latitude: ${JSON.stringify(input.latitude)}` : MISSING,
    input.longitude !== undefined ? `longitude: ${JSON.stringify(input.longitude)}` : MISSING,
    input.pType !== undefined ? `pType: ${JSON.stringify(input.pType)}` : MISSING,
    input.io_cnt_func !== undefined ? `io_cnt_func: ${JSON.stringify(input.io_cnt_func)}` : MISSING,
    input.io_out_used !== undefined ? `io_out_used: ${JSON.stringify(input.io_out_used)}` : MISSING,
    input.io_ing_used !== undefined ? `io_ing_used: ${JSON.stringify(input.io_ing_used)}` : MISSING,
    input.sensor_mode !== undefined ? `sensor_mode: ${JSON.stringify(input.sensor_mode)}` : MISSING,
    input.ext_device !== undefined ? `ext_device: ${JSON.stringify(input.ext_device)}` : MISSING,
    input.connection !== undefined ? `connection: ${JSON.stringify(input.connection)}` : MISSING,
    input.net !== undefined ? `net: ${JSON.stringify(input.net)}` : MISSING,
    input.configVerified !== undefined ? `configVerified: ${JSON.stringify(input.configVerified)}` : MISSING,
    input.mt_sign !== undefined ? `mt_sign: ${JSON.stringify(input.mt_sign)}` : MISSING,
    input.mt_active !== undefined ? `mt_active: ${JSON.stringify(input.mt_active)}` : MISSING,
    input.mt_pb !== undefined ? `mt_pb: ${JSON.stringify(input.mt_pb)}` : MISSING,
    input.tas_en !== undefined ? `tas_en: ${JSON.stringify(input.tas_en)}` : MISSING,
    input.tas_pb !== undefined ? `tas_pb: ${JSON.stringify(input.tas_pb)}` : MISSING,
    input.tap_en !== undefined ? `tap_en: ${JSON.stringify(input.tap_en)}` : MISSING,
    input.tap_pb !== undefined ? `tap_pb: ${JSON.stringify(input.tap_pb)}` : MISSING,
    input.num_device !== undefined ? `num_device: ${JSON.stringify(input.num_device)}` : MISSING,
    input.ta_sign !== undefined ? `ta_sign: ${JSON.stringify(input.ta_sign)}` : MISSING,
    input.pext !== undefined ? `pext: ${JSON.stringify(input.pext)}` : MISSING,
    input.error_id !== undefined ? `error_id: ${JSON.stringify(input.error_id)}` : MISSING,
    input.error_ts !== undefined ? `error_ts: ${JSON.stringify(input.error_ts)}` : MISSING,
    input.virtualRTStatus !== undefined ? `virtualRTStatus: ${serializeVirtualRTStateInput(input.virtualRTStatus)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeVirtualRTStateInput = (input: VirtualRTStateInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.active !== undefined ? `active: ${JSON.stringify(input.active)}` : MISSING,
    input.startTS !== undefined ? `startTS: ${JSON.stringify(input.startTS)}` : MISSING,
    input.duration !== undefined ? `duration: ${JSON.stringify(input.duration)}` : MISSING,
    input.target !== undefined ? `target: ${JSON.stringify(input.target)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeEmsStateInput = (input: EmsStateInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.connext !== undefined ? `connext: ${serializeConnextDataInput(input.connext)}` : MISSING,
    input.azzurro_hub !== undefined ? `azzurro_hub: ${serializeAzzurroHubDataInput(input.azzurro_hub)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAzzurroHubDataInput = (input: AzzurroHubDataInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.config !== undefined ? `config: ${serializeAzzurroHubConfigInput(input.config)}` : MISSING,
    input.inverter !== undefined ? `inverter: ${input.inverter?.map((item) => serializeAHinverterInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.meter !== undefined ? `meter: ${input.meter?.map((item) => serializeAHmeterInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.evChargerCAN !== undefined ? `evChargerCAN: ${input.evChargerCAN?.map((item) => serializeAHevChargerCANInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.evCharger485 !== undefined ? `evCharger485: ${input.evCharger485?.map((item) => serializeAHevCharger485Input(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.pwrMagic !== undefined ? `pwrMagic: ${input.pwrMagic?.map((item) => serializeAHpowerMagicInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.heatPump !== undefined ? `heatPump: ${input.heatPump?.map((item) => serializeAHheatPumpInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.solarSensor !== undefined ? `solarSensor: ${input.solarSensor?.map((item) => serializeAHsolarSensorInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.PSC100 !== undefined ? `PSC100: ${input.PSC100?.map((item) => serializeAHpsc100Input(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.info !== undefined ? `info: ${serializeAzzurroHubInfoInput(input.info)}` : MISSING,
    input.lan !== undefined ? `lan: ${serializeAzzurroHubLanInput(input.lan)}` : MISSING,
    input.loggerId !== undefined ? `loggerId: ${JSON.stringify(input.loggerId)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAzzurroHubConfigInput = (input: AzzurroHubConfigInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.country !== undefined ? `country: ${JSON.stringify(input.country)}` : MISSING,
    input.IANA !== undefined ? `IANA: ${JSON.stringify(input.IANA)}` : MISSING,
    input.actPwrCtrlAlgo !== undefined ? `actPwrCtrlAlgo: ${input.actPwrCtrlAlgo}` : MISSING,
    input.actPwrCtrlEna !== undefined ? `actPwrCtrlEna: ${JSON.stringify(input.actPwrCtrlEna)}` : MISSING,
    input.actPwrCtrlTarget !== undefined ? `actPwrCtrlTarget: ${JSON.stringify(input.actPwrCtrlTarget)}` : MISSING,
    input.intSensorInversion !== undefined ? `intSensorInversion: ${input.intSensorInversion}` : MISSING,
    input.maxContractualPwr !== undefined ? `maxContractualPwr: ${JSON.stringify(input.maxContractualPwr)}` : MISSING,
    input.maxPlantInvPwr !== undefined ? `maxPlantInvPwr: ${JSON.stringify(input.maxPlantInvPwr)}` : MISSING,
    input.monitoringMode !== undefined ? `monitoringMode: ${input.monitoringMode}` : MISSING,
    input.plantPhases !== undefined ? `plantPhases: ${input.plantPhases}` : MISSING,
    input.evchCtrlEna !== undefined ? `evchCtrlEna: ${JSON.stringify(input.evchCtrlEna)}` : MISSING,
    input.evchTimeModeEna !== undefined ? `evchTimeModeEna: ${JSON.stringify(input.evchTimeModeEna)}` : MISSING,
    input.evchTimeStart !== undefined ? `evchTimeStart: ${JSON.stringify(input.evchTimeStart)}` : MISSING,
    input.evchTimeStop !== undefined ? `evchTimeStop: ${JSON.stringify(input.evchTimeStop)}` : MISSING,
    input.evchBatteryProtectEna !== undefined ? `evchBatteryProtectEna: ${JSON.stringify(input.evchBatteryProtectEna)}` : MISSING,
    input.evchBatterySOCLimit !== undefined ? `evchBatterySOCLimit: ${JSON.stringify(input.evchBatterySOCLimit)}` : MISSING,
    input.evchPwrImportLimit !== undefined ? `evchPwrImportLimit: ${JSON.stringify(input.evchPwrImportLimit)}` : MISSING,
    input.evchPwrImportValue !== undefined ? `evchPwrImportValue: ${JSON.stringify(input.evchPwrImportValue)}` : MISSING,
    input.evchParallelEna !== undefined ? `evchParallelEna: ${JSON.stringify(input.evchParallelEna)}` : MISSING,
    input.evchStrategy !== undefined ? `evchStrategy: ${input.evchStrategy}` : MISSING,
    input.scanDevices !== undefined ? `scanDevices: ${input.scanDevices}` : MISSING,
    input.operational !== undefined ? `operational: ${input.operational}` : MISSING,
    input.plantDetectType !== undefined ? `plantDetectType: ${input.plantDetectType}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
    input.virtualRTStatus !== undefined ? `virtualRTStatus: ${serializeVirtualRTStateInput(input.virtualRTStatus)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHinverterInput = (input: AHinverterInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.deviceType !== undefined ? `deviceType: ${input.deviceType}` : MISSING,
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.connected !== undefined ? `connected: ${JSON.stringify(input.connected)}` : MISSING,
    input.removed !== undefined ? `removed: ${JSON.stringify(input.removed)}` : MISSING,
    input.modbusAdr !== undefined ? `modbusAdr: ${JSON.stringify(input.modbusAdr)}` : MISSING,
    input.hwVer !== undefined ? `hwVer: ${JSON.stringify(input.hwVer)}` : MISSING,
    input.arm !== undefined ? `arm: ${JSON.stringify(input.arm)}` : MISSING,
    input.dspm !== undefined ? `dspm: ${JSON.stringify(input.dspm)}` : MISSING,
    input.dsps !== undefined ? `dsps: ${JSON.stringify(input.dsps)}` : MISSING,
    input.updating !== undefined ? `updating: ${JSON.stringify(input.updating)}` : MISSING,
    input.upd_arm !== undefined ? `upd_arm: ${serializeModuleUpdateInput(input.upd_arm)}` : MISSING,
    input.upd_dspm !== undefined ? `upd_dspm: ${serializeModuleUpdateInput(input.upd_dspm)}` : MISSING,
    input.upd_dsps !== undefined ? `upd_dsps: ${serializeModuleUpdateInput(input.upd_dsps)}` : MISSING,
    input.upd_safety !== undefined ? `upd_safety: ${serializeModuleUpdateInput(input.upd_safety)}` : MISSING,
    input.upd_sofar !== undefined ? `upd_sofar: ${serializeModuleUpdateInput(input.upd_sofar)}` : MISSING,
    input.safetyVer !== undefined ? `safetyVer: ${JSON.stringify(input.safetyVer)}` : MISSING,
    input.country !== undefined ? `country: ${JSON.stringify(input.country)}` : MISSING,
    input.region !== undefined ? `region: ${JSON.stringify(input.region)}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHmeterInput = (input: AHmeterInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.deviceType !== undefined ? `deviceType: ${input.deviceType}` : MISSING,
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.connected !== undefined ? `connected: ${JSON.stringify(input.connected)}` : MISSING,
    input.removed !== undefined ? `removed: ${JSON.stringify(input.removed)}` : MISSING,
    input.modbusAdr !== undefined ? `modbusAdr: ${JSON.stringify(input.modbusAdr)}` : MISSING,
    input.model !== undefined ? `model: ${input.model}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHevChargerCANInput = (input: AHevChargerCANInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.deviceType !== undefined ? `deviceType: ${input.deviceType}` : MISSING,
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.connected !== undefined ? `connected: ${JSON.stringify(input.connected)}` : MISSING,
    input.removed !== undefined ? `removed: ${JSON.stringify(input.removed)}` : MISSING,
    input.sts !== undefined ? `sts: ${input.sts}` : MISSING,
    input.swVer !== undefined ? `swVer: ${JSON.stringify(input.swVer)}` : MISSING,
    input.type !== undefined ? `type: ${JSON.stringify(input.type)}` : MISSING,
    input.alerts !== undefined ? `alerts: ${JSON.stringify(input.alerts)}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHevCharger485Input = (input: AHevCharger485Input) => {
  const MISSING = 'MISSING';
  const parts = [
    input.deviceType !== undefined ? `deviceType: ${input.deviceType}` : MISSING,
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.connected !== undefined ? `connected: ${JSON.stringify(input.connected)}` : MISSING,
    input.removed !== undefined ? `removed: ${JSON.stringify(input.removed)}` : MISSING,
    input.modbusAdr !== undefined ? `modbusAdr: ${JSON.stringify(input.modbusAdr)}` : MISSING,
    input.sts !== undefined ? `sts: ${input.sts}` : MISSING,
    input.swVer !== undefined ? `swVer: ${JSON.stringify(input.swVer)}` : MISSING,
    input.alerts !== undefined ? `alerts: ${JSON.stringify(input.alerts)}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHpowerMagicInput = (input: AHpowerMagicInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.deviceType !== undefined ? `deviceType: ${input.deviceType}` : MISSING,
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.connected !== undefined ? `connected: ${JSON.stringify(input.connected)}` : MISSING,
    input.removed !== undefined ? `removed: ${JSON.stringify(input.removed)}` : MISSING,
    input.ipAddr !== undefined ? `ipAddr: ${JSON.stringify(input.ipAddr)}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHheatPumpInput = (input: AHheatPumpInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.deviceType !== undefined ? `deviceType: ${input.deviceType}` : MISSING,
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.connected !== undefined ? `connected: ${JSON.stringify(input.connected)}` : MISSING,
    input.removed !== undefined ? `removed: ${JSON.stringify(input.removed)}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
    input.modbusAdr !== undefined ? `modbusAdr: ${JSON.stringify(input.modbusAdr)}` : MISSING,
    input.globStatus !== undefined ? `globStatus: ${input.globStatus}` : MISSING,
    input.DHWOn !== undefined ? `DHWOn: ${JSON.stringify(input.DHWOn)}` : MISSING,
    input.climOnA !== undefined ? `climOnA: ${JSON.stringify(input.climOnA)}` : MISSING,
    input.DHWSetTemp !== undefined ? `DHWSetTemp: ${JSON.stringify(input.DHWSetTemp)}` : MISSING,
    input.climOpMode !== undefined ? `climOpMode: ${input.climOpMode}` : MISSING,
    input.climSetTempHeatingA !== undefined ? `climSetTempHeatingA: ${JSON.stringify(input.climSetTempHeatingA)}` : MISSING,
    input.climSetTempCoolingA !== undefined ? `climSetTempCoolingA: ${JSON.stringify(input.climSetTempCoolingA)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHsolarSensorInput = (input: AHsolarSensorInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.deviceType !== undefined ? `deviceType: ${input.deviceType}` : MISSING,
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.connected !== undefined ? `connected: ${JSON.stringify(input.connected)}` : MISSING,
    input.removed !== undefined ? `removed: ${JSON.stringify(input.removed)}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHpsc100Input = (input: AHpsc100Input) => {
  const MISSING = 'MISSING';
  const parts = [
    input.deviceType !== undefined ? `deviceType: ${input.deviceType}` : MISSING,
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.connected !== undefined ? `connected: ${JSON.stringify(input.connected)}` : MISSING,
    input.removed !== undefined ? `removed: ${JSON.stringify(input.removed)}` : MISSING,
    input.app !== undefined ? `app: ${JSON.stringify(input.app)}` : MISSING,
    input.gcp !== undefined ? `gcp: ${JSON.stringify(input.gcp)}` : MISSING,
    input.PBUSCCO1 !== undefined ? `PBUSCCO1: ${JSON.stringify(input.PBUSCCO1)}` : MISSING,
    input.PBUSCCO2 !== undefined ? `PBUSCCO2: ${JSON.stringify(input.PBUSCCO2)}` : MISSING,
    input.core !== undefined ? `core: ${JSON.stringify(input.core)}` : MISSING,
    input.sdk !== undefined ? `sdk: ${JSON.stringify(input.sdk)}` : MISSING,
    input.inverters !== undefined ? `inverters: ${input.inverters?.map((item) => serializeAHpsc100InvertersInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHpsc100InvertersInput = (input: AHpsc100InvertersInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAzzurroHubInfoInput = (input: AzzurroHubInfoInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.fw !== undefined ? `fw: ${serializeAHinfoFwInput(input.fw)}` : MISSING,
    input.upd !== undefined ? `upd: ${serializeAHinfoLoggerUpgradeInput(input.upd)}` : MISSING,
    input.connection !== undefined ? `connection: ${serializeAHConnectionInput(input.connection)}` : MISSING,
    input.sn !== undefined ? `sn: ${serializeAHSNInput(input.sn)}` : MISSING,
    input.name !== undefined ? `name: ${serializeAHNameInput(input.name)}` : MISSING,
    input.hwv !== undefined ? `hwv: ${serializeAHHwVInput(input.hwv)}` : MISSING,
    input.def !== undefined ? `def: ${serializeAHDefInput(input.def)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHinfoFwInput = (input: AHinfoFwInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.currVer !== undefined ? `currVer: ${JSON.stringify(input.currVer)}` : MISSING,
    input.shadowVer !== undefined ? `shadowVer: ${JSON.stringify(input.shadowVer)}` : MISSING,
    input.currBootSlot !== undefined ? `currBootSlot: ${input.currBootSlot}` : MISSING,
    input.bootSts !== undefined ? `bootSts: ${input.bootSts}` : MISSING,
    input.bootErr !== undefined ? `bootErr: ${JSON.stringify(input.bootErr)}` : MISSING,
    input.hwVer !== undefined ? `hwVer: ${JSON.stringify(input.hwVer)}` : MISSING,
    input.dateProd !== undefined ? `dateProd: ${JSON.stringify(input.dateProd)}` : MISSING,
    input.scriptVer !== undefined ? `scriptVer: ${JSON.stringify(input.scriptVer)}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHinfoLoggerUpgradeInput = (input: AHinfoLoggerUpgradeInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.result !== undefined ? `result: ${JSON.stringify(input.result)}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHConnectionInput = (input: AHConnectionInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.status !== undefined ? `status: ${JSON.stringify(input.status)}` : MISSING,
    input.disconnectReason !== undefined ? `disconnectReason: ${JSON.stringify(input.disconnectReason)}` : MISSING,
    input.ipAddress !== undefined ? `ipAddress: ${JSON.stringify(input.ipAddress)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHSNInput = (input: AHSNInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.uid !== undefined ? `uid: ${JSON.stringify(input.uid)}` : MISSING,
    input.type !== undefined ? `type: ${JSON.stringify(input.type)}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHNameInput = (input: AHNameInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.name !== undefined ? `name: ${JSON.stringify(input.name)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHHwVInput = (input: AHHwVInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.hwVer !== undefined ? `hwVer: ${JSON.stringify(input.hwVer)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAHDefInput = (input: AHDefInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.thingDef !== undefined ? `thingDef: ${JSON.stringify(input.thingDef)}` : MISSING,
    input.type !== undefined ? `type: ${JSON.stringify(input.type)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAzzurroHubLanInput = (input: AzzurroHubLanInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.eth_DHCP !== undefined ? `eth_DHCP: ${JSON.stringify(input.eth_DHCP)}` : MISSING,
    input.eth_DNS1 !== undefined ? `eth_DNS1: ${JSON.stringify(input.eth_DNS1)}` : MISSING,
    input.eth_DNS2 !== undefined ? `eth_DNS2: ${JSON.stringify(input.eth_DNS2)}` : MISSING,
    input.eth_enabled !== undefined ? `eth_enabled: ${JSON.stringify(input.eth_enabled)}` : MISSING,
    input.eth_ip !== undefined ? `eth_ip: ${JSON.stringify(input.eth_ip)}` : MISSING,
    input.eth_online !== undefined ? `eth_online: ${JSON.stringify(input.eth_online)}` : MISSING,
    input.eth_routerIP !== undefined ? `eth_routerIP: ${JSON.stringify(input.eth_routerIP)}` : MISSING,
    input.eth_status !== undefined ? `eth_status: ${input.eth_status}` : MISSING,
    input.wifi_DHCP !== undefined ? `wifi_DHCP: ${JSON.stringify(input.wifi_DHCP)}` : MISSING,
    input.wifi_DNS1 !== undefined ? `wifi_DNS1: ${JSON.stringify(input.wifi_DNS1)}` : MISSING,
    input.wifi_DNS2 !== undefined ? `wifi_DNS2: ${JSON.stringify(input.wifi_DNS2)}` : MISSING,
    input.wifi_enabled !== undefined ? `wifi_enabled: ${JSON.stringify(input.wifi_enabled)}` : MISSING,
    input.wifi_ip !== undefined ? `wifi_ip: ${JSON.stringify(input.wifi_ip)}` : MISSING,
    input.wifi_online !== undefined ? `wifi_online: ${JSON.stringify(input.wifi_online)}` : MISSING,
    input.wifi_routerIP !== undefined ? `wifi_routerIP: ${JSON.stringify(input.wifi_routerIP)}` : MISSING,
    input.wifi_SSID !== undefined ? `wifi_SSID: ${JSON.stringify(input.wifi_SSID)}` : MISSING,
    input.wifi_status !== undefined ? `wifi_status: ${input.wifi_status}` : MISSING,
    input.wifi_strength !== undefined ? `wifi_strength: ${JSON.stringify(input.wifi_strength)}` : MISSING,
    input.updatedAt !== undefined ? `updatedAt: ${JSON.stringify(input.updatedAt)}` : MISSING,
    input.createdAt !== undefined ? `createdAt: ${JSON.stringify(input.createdAt)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializePlantMyUserInput = (input: PlantMyUserInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.email !== undefined ? `email: ${JSON.stringify(input.email)}` : MISSING,
    input.userLevel !== undefined ? `userLevel: ${JSON.stringify(input.userLevel)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializePlantGeoInput = (input: PlantGeoInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.latitude !== undefined ? `latitude: ${JSON.stringify(input.latitude)}` : MISSING,
    input.longitude !== undefined ? `longitude: ${JSON.stringify(input.longitude)}` : MISSING,
    input.IANA !== undefined ? `IANA: ${JSON.stringify(input.IANA)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializePlantConfigInput = (input: PlantConfigInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.contractualPower !== undefined ? `contractualPower: ${JSON.stringify(input.contractualPower)}` : MISSING,
    input.meterInversion !== undefined ? `meterInversion: ${JSON.stringify(input.meterInversion)}` : MISSING,
    input.phase !== undefined ? `phase: ${input.phase}` : MISSING,
    input.monitoringType !== undefined ? `monitoringType: ${input.monitoringType}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializePlantPrefInput = (input: PlantPrefInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.monitorPref !== undefined ? `monitorPref: ${input.monitorPref}` : MISSING,
    input.plantName !== undefined ? `plantName: ${JSON.stringify(input.plantName)}` : MISSING,
    input.tagsDevices !== undefined ? `tagsDevices: ${input.tagsDevices?.map((item) => serializeTagsDevicesInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeTagsDevicesInput = (input: TagsDevicesInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.key !== undefined ? `key: ${JSON.stringify(input.key)}` : MISSING,
    input.value !== undefined ? `value: ${JSON.stringify(input.value)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeCreateCertifiedPlant = (input: CreateCertifiedPlant) => {
  const MISSING = 'MISSING';
  const parts = [
    input.config !== undefined ? `config: ${serializePlantConfigInput(input.config)}` : MISSING,
    input.devices !== undefined ? `devices: ${input.devices.map((item) => serializeCreatePlantDeviceInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.ems !== undefined ? `ems: ${serializeCreatePlantEmsInput(input.ems)}` : MISSING,
    input.users !== undefined ? `users: ${input.users.map((item) => serializeCreatePlantUserInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.plantUserPrefs !== undefined ? `plantUserPrefs: ${serializeCreatePlantUserPrefInput(input.plantUserPrefs)}` : MISSING,
    input.geo !== undefined ? `geo: ${serializePlantGeoInput(input.geo)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeCreatePlantDeviceInput = (input: CreatePlantDeviceInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.type !== undefined ? `type: ${input.type}` : MISSING,
    input.installationTime !== undefined ? `installationTime: ${JSON.stringify(input.installationTime)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeCreatePlantEmsInput = (input: CreatePlantEmsInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
    input.type !== undefined ? `type: ${input.type}` : MISSING,
    input.installationTime !== undefined ? `installationTime: ${JSON.stringify(input.installationTime)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeCreatePlantUserInput = (input: CreatePlantUserInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.email !== undefined ? `email: ${JSON.stringify(input.email)}` : MISSING,
    input.userLevel !== undefined ? `userLevel: ${JSON.stringify(input.userLevel)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeCreatePlantUserPrefInput = (input: CreatePlantUserPrefInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.monitorPref !== undefined ? `monitorPref: ${input.monitorPref}` : MISSING,
    input.plantName !== undefined ? `plantName: ${JSON.stringify(input.plantName)}` : MISSING,
    input.tagsDevices !== undefined ? `tagsDevices: ${input.tagsDevices?.map((item) => serializeTagsDevicesInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeReceiveCommandStringInput = (input: ReceiveCommandStringInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.transactionId !== undefined ? `transactionId: ${JSON.stringify(input.transactionId)}` : MISSING,
    input.version !== undefined ? `version: ${JSON.stringify(input.version)}` : MISSING,
    input.deviceId !== undefined ? `deviceId: ${JSON.stringify(input.deviceId)}` : MISSING,
    input.inverterId !== undefined ? `inverterId: ${JSON.stringify(input.inverterId)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.dataType !== undefined ? `dataType: ${JSON.stringify(input.dataType)}` : MISSING,
    input.result !== undefined ? `result: ${JSON.stringify(input.result)}` : MISSING,
    input.commandResponse !== undefined ? `commandResponse: ${JSON.stringify(input.commandResponse)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAdvancedEventConfigurationInput = (input: AdvancedEventConfigurationInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.emailList !== undefined ? `emailList: ${input.emailList?.map((item) => JSON.stringify(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
    input.eventModelsName !== undefined ? `eventModelsName: ${input.eventModelsName?.map((item) => item).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeEventNotificationConfigInput = (input: EventNotificationConfigInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.eventsOperation !== undefined ? `eventsOperation: ${input.eventsOperation}` : MISSING,
    input.events !== undefined ? `events: ${serializeEventNotificationItemInput(input.events)}` : MISSING,
    input.emails !== undefined ? `emails: ${input.emails?.map((item) => JSON.stringify(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeEventNotificationItemInput = (input: EventNotificationItemInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.AcCurrentUnbalanceFault !== undefined ? `AcCurrentUnbalanceFault: ${serializeEventNotificationPayloadBaseInput(input.AcCurrentUnbalanceFault)}` : MISSING,
    input.AcHardwareOvercurrentFault !== undefined ? `AcHardwareOvercurrentFault: ${serializeEventNotificationPayloadBaseInput(input.AcHardwareOvercurrentFault)}` : MISSING,
    input.BatteryLow !== undefined ? `BatteryLow: ${serializeEventNotificationBatteryLowPayloadInput(input.BatteryLow)}` : MISSING,
    input.BatteryLowVoltageShutdown !== undefined ? `BatteryLowVoltageShutdown: ${serializeEventNotificationPayloadBaseInput(input.BatteryLowVoltageShutdown)}` : MISSING,
    input.BMS1CommunicatonFault !== undefined ? `BMS1CommunicatonFault: ${serializeEventNotificationPayloadBaseInput(input.BMS1CommunicatonFault)}` : MISSING,
    input.BMS2CommunicatonFault !== undefined ? `BMS2CommunicatonFault: ${serializeEventNotificationPayloadBaseInput(input.BMS2CommunicatonFault)}` : MISSING,
    input.BMSOvervoltageProtection !== undefined ? `BMSOvervoltageProtection: ${serializeEventNotificationPayloadBaseInput(input.BMSOvervoltageProtection)}` : MISSING,
    input.BMSUndervoltageProtection !== undefined ? `BMSUndervoltageProtection: ${serializeEventNotificationPayloadBaseInput(input.BMSUndervoltageProtection)}` : MISSING,
    input.BMSVerFault !== undefined ? `BMSVerFault: ${serializeEventNotificationPayloadBaseInput(input.BMSVerFault)}` : MISSING,
    input.ZBTS5kSleepMode !== undefined ? `ZBTS5kSleepMode: ${serializeEventNotificationZBTS5kSleepModePayloadInput(input.ZBTS5kSleepMode)}` : MISSING,
    input.BusHardwareOvervoltageFault !== undefined ? `BusHardwareOvervoltageFault: ${serializeEventNotificationPayloadBaseInput(input.BusHardwareOvervoltageFault)}` : MISSING,
    input.BusOvervoltageFault !== undefined ? `BusOvervoltageFault: ${serializeEventNotificationPayloadBaseInput(input.BusOvervoltageFault)}` : MISSING,
    input.BusUnbalanceFault !== undefined ? `BusUnbalanceFault: ${serializeEventNotificationPayloadBaseInput(input.BusUnbalanceFault)}` : MISSING,
    input.CTError !== undefined ? `CTError: ${serializeEventNotificationPayloadBaseInput(input.CTError)}` : MISSING,
    input.EpsBatteryOvercurrentFault !== undefined ? `EpsBatteryOvercurrentFault: ${serializeEventNotificationPayloadBaseInput(input.EpsBatteryOvercurrentFault)}` : MISSING,
    input.Fan1Failure !== undefined ? `Fan1Failure: ${serializeEventNotificationPayloadBaseInput(input.Fan1Failure)}` : MISSING,
    input.Fan2Failure !== undefined ? `Fan2Failure: ${serializeEventNotificationPayloadBaseInput(input.Fan2Failure)}` : MISSING,
    input.Fan3Failure !== undefined ? `Fan3Failure: ${serializeEventNotificationPayloadBaseInput(input.Fan3Failure)}` : MISSING,
    input.Fan4Failure !== undefined ? `Fan4Failure: ${serializeEventNotificationPayloadBaseInput(input.Fan4Failure)}` : MISSING,
    input.Fan5Failure !== undefined ? `Fan5Failure: ${serializeEventNotificationPayloadBaseInput(input.Fan5Failure)}` : MISSING,
    input.Fan6Failure !== undefined ? `Fan6Failure: ${serializeEventNotificationPayloadBaseInput(input.Fan6Failure)}` : MISSING,
    input.Fan7Failure !== undefined ? `Fan7Failure: ${serializeEventNotificationPayloadBaseInput(input.Fan7Failure)}` : MISSING,
    input.GridOverfrequency !== undefined ? `GridOverfrequency: ${serializeEventNotificationPayloadBaseInput(input.GridOverfrequency)}` : MISSING,
    input.GridOvervoltage !== undefined ? `GridOvervoltage: ${serializeEventNotificationPayloadBaseInput(input.GridOvervoltage)}` : MISSING,
    input.GridUnderfrequency !== undefined ? `GridUnderfrequency: ${serializeEventNotificationPayloadBaseInput(input.GridUnderfrequency)}` : MISSING,
    input.GridUndervoltage !== undefined ? `GridUndervoltage: ${serializeEventNotificationPayloadBaseInput(input.GridUndervoltage)}` : MISSING,
    input.InconsistentSoftwareVersion !== undefined ? `InconsistentSoftwareVersion: ${serializeEventNotificationPayloadBaseInput(input.InconsistentSoftwareVersion)}` : MISSING,
    input.InputModeSettingFailure !== undefined ? `InputModeSettingFailure: ${serializeEventNotificationPayloadBaseInput(input.InputModeSettingFailure)}` : MISSING,
    input.InputOvercurrentFault !== undefined ? `InputOvercurrentFault: ${serializeEventNotificationPayloadBaseInput(input.InputOvercurrentFault)}` : MISSING,
    input.InverterSoftStartFailure !== undefined ? `InverterSoftStartFailure: ${serializeEventNotificationPayloadBaseInput(input.InverterSoftStartFailure)}` : MISSING,
    input.IslandingError !== undefined ? `IslandingError: ${serializeEventNotificationPayloadBaseInput(input.IslandingError)}` : MISSING,
    input.LeakageCurrentFault !== undefined ? `LeakageCurrentFault: ${serializeEventNotificationPayloadBaseInput(input.LeakageCurrentFault)}` : MISSING,
    input.LowInsulationResistance !== undefined ? `LowInsulationResistance: ${serializeEventNotificationPayloadBaseInput(input.LowInsulationResistance)}` : MISSING,
    input.MeterError !== undefined ? `MeterError: ${serializeEventNotificationPayloadBaseInput(input.MeterError)}` : MISSING,
    input.OutputInstantaneousOvercurrentFault !== undefined ? `OutputInstantaneousOvercurrentFault: ${serializeEventNotificationPayloadBaseInput(input.OutputInstantaneousOvercurrentFault)}` : MISSING,
    input.PVOvervoltage !== undefined ? `PVOvervoltage: ${serializeEventNotificationPayloadBaseInput(input.PVOvervoltage)}` : MISSING,
    input.PvUnevenCurrentFault !== undefined ? `PvUnevenCurrentFault: ${serializeEventNotificationPayloadBaseInput(input.PvUnevenCurrentFault)}` : MISSING,
    input.RelayDetectionFailure !== undefined ? `RelayDetectionFailure: ${serializeEventNotificationPayloadBaseInput(input.RelayDetectionFailure)}` : MISSING,
    input.RelayUnbalancedPermanentFailure !== undefined ? `RelayUnbalancedPermanentFailure: ${serializeEventNotificationPayloadBaseInput(input.RelayUnbalancedPermanentFailure)}` : MISSING,
    input.SCIError_AC !== undefined ? `SCIError_AC: ${serializeEventNotificationPayloadBaseInput(input.SCIError_AC)}` : MISSING,
    input.SCIError_DC !== undefined ? `SCIError_DC: ${serializeEventNotificationPayloadBaseInput(input.SCIError_DC)}` : MISSING,
    input.SCIError_Fuse !== undefined ? `SCIError_Fuse: ${serializeEventNotificationPayloadBaseInput(input.SCIError_Fuse)}` : MISSING,
    input.SPICommError_AC !== undefined ? `SPICommError_AC: ${serializeEventNotificationPayloadBaseInput(input.SPICommError_AC)}` : MISSING,
    input.SPICommError_DC !== undefined ? `SPICommError_DC: ${serializeEventNotificationPayloadBaseInput(input.SPICommError_DC)}` : MISSING,
    input.SafetyVerFault !== undefined ? `SafetyVerFault: ${serializeEventNotificationPayloadBaseInput(input.SafetyVerFault)}` : MISSING,
    input.WeakBattery !== undefined ? `WeakBattery: ${serializeEventNotificationWeakBatteryPayloadInput(input.WeakBattery)}` : MISSING,
    input.GPMError !== undefined ? `GPMError: ${serializeEventNotificationPayloadBaseInput(input.GPMError)}` : MISSING,
    input.GPMWarning !== undefined ? `GPMWarning: ${serializeEventNotificationPayloadBaseInput(input.GPMWarning)}` : MISSING,
    input.GPMNotice !== undefined ? `GPMNotice: ${serializeEventNotificationPayloadBaseInput(input.GPMNotice)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeEventNotificationPayloadBaseInput = (input: EventNotificationPayloadBaseInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.activeTimeMinutes !== undefined ? `activeTimeMinutes: ${JSON.stringify(input.activeTimeMinutes)}` : MISSING,
    input.recurringEmailIntervalMinutes !== undefined ? `recurringEmailIntervalMinutes: ${JSON.stringify(input.recurringEmailIntervalMinutes)}` : MISSING,
    input.snoozeDurationMinutes !== undefined ? `snoozeDurationMinutes: ${JSON.stringify(input.snoozeDurationMinutes)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeEventNotificationBatteryLowPayloadInput = (input: EventNotificationBatteryLowPayloadInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.activeTimeMinutes !== undefined ? `activeTimeMinutes: ${JSON.stringify(input.activeTimeMinutes)}` : MISSING,
    input.recurringEmailIntervalMinutes !== undefined ? `recurringEmailIntervalMinutes: ${JSON.stringify(input.recurringEmailIntervalMinutes)}` : MISSING,
    input.snoozeDurationMinutes !== undefined ? `snoozeDurationMinutes: ${JSON.stringify(input.snoozeDurationMinutes)}` : MISSING,
    input.voltageThreshold !== undefined ? `voltageThreshold: ${JSON.stringify(input.voltageThreshold)}` : MISSING,
    input.socThreshold !== undefined ? `socThreshold: ${JSON.stringify(input.socThreshold)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeEventNotificationZBTS5kSleepModePayloadInput = (input: EventNotificationZBTS5kSleepModePayloadInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.activeTimeMinutes !== undefined ? `activeTimeMinutes: ${JSON.stringify(input.activeTimeMinutes)}` : MISSING,
    input.recurringEmailIntervalMinutes !== undefined ? `recurringEmailIntervalMinutes: ${JSON.stringify(input.recurringEmailIntervalMinutes)}` : MISSING,
    input.snoozeDurationMinutes !== undefined ? `snoozeDurationMinutes: ${JSON.stringify(input.snoozeDurationMinutes)}` : MISSING,
    input.sleepModeDurationMinutes !== undefined ? `sleepModeDurationMinutes: ${JSON.stringify(input.sleepModeDurationMinutes)}` : MISSING,
    input.socThreshold !== undefined ? `socThreshold: ${JSON.stringify(input.socThreshold)}` : MISSING,
    input.minVoltageThreshold !== undefined ? `minVoltageThreshold: ${JSON.stringify(input.minVoltageThreshold)}` : MISSING,
    input.maxVoltageThreshold !== undefined ? `maxVoltageThreshold: ${JSON.stringify(input.maxVoltageThreshold)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeEventNotificationWeakBatteryPayloadInput = (input: EventNotificationWeakBatteryPayloadInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.activeTimeMinutes !== undefined ? `activeTimeMinutes: ${JSON.stringify(input.activeTimeMinutes)}` : MISSING,
    input.recurringEmailIntervalMinutes !== undefined ? `recurringEmailIntervalMinutes: ${JSON.stringify(input.recurringEmailIntervalMinutes)}` : MISSING,
    input.snoozeDurationMinutes !== undefined ? `snoozeDurationMinutes: ${JSON.stringify(input.snoozeDurationMinutes)}` : MISSING,
    input.voltageThreshold !== undefined ? `voltageThreshold: ${JSON.stringify(input.voltageThreshold)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSendInvUpgradeInput = (input: SendInvUpgradeInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.loggerId !== undefined ? `loggerId: ${JSON.stringify(input.loggerId)}` : MISSING,
    input.inverterId !== undefined ? `inverterId: ${JSON.stringify(input.inverterId)}` : MISSING,
    input.fileType !== undefined ? `fileType: ${JSON.stringify(input.fileType)}` : MISSING,
    input.fileCRC !== undefined ? `fileCRC: ${JSON.stringify(input.fileCRC)}` : MISSING,
    input.fileURL !== undefined ? `fileURL: ${JSON.stringify(input.fileURL)}` : MISSING,
    input.fileSize !== undefined ? `fileSize: ${JSON.stringify(input.fileSize)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeReceiveInvUpgradeInput = (input: ReceiveInvUpgradeInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.transactionId !== undefined ? `transactionId: ${JSON.stringify(input.transactionId)}` : MISSING,
    input.version !== undefined ? `version: ${JSON.stringify(input.version)}` : MISSING,
    input.deviceId !== undefined ? `deviceId: ${JSON.stringify(input.deviceId)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.dataType !== undefined ? `dataType: ${JSON.stringify(input.dataType)}` : MISSING,
    input.result !== undefined ? `result: ${JSON.stringify(input.result)}` : MISSING,
    input.fileType !== undefined ? `fileType: ${JSON.stringify(input.fileType)}` : MISSING,
    input.message !== undefined ? `message: ${JSON.stringify(input.message)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeReceiveInvUpgradeByEthInput = (input: ReceiveInvUpgradeByEthInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.transactionId !== undefined ? `transactionId: ${JSON.stringify(input.transactionId)}` : MISSING,
    input.cid !== undefined ? `cid: ${JSON.stringify(input.cid)}` : MISSING,
    input.s !== undefined ? `s: ${JSON.stringify(input.s)}` : MISSING,
    input.d !== undefined ? `d: ${JSON.stringify(input.d)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.st !== undefined ? `st: ${JSON.stringify(input.st)}` : MISSING,
    input.mod !== undefined ? `mod: ${JSON.stringify(input.mod)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeLoggerUpdateLog = (input: LoggerUpdateLog) => {
  const MISSING = 'MISSING';
  const parts = [
    input.device_sn !== undefined ? `device_sn: ${JSON.stringify(input.device_sn)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.starting_version !== undefined ? `starting_version: ${JSON.stringify(input.starting_version)}` : MISSING,
    input.target_version !== undefined ? `target_version: ${JSON.stringify(input.target_version)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeDeviceUpdateLog = (input: DeviceUpdateLog) => {
  const MISSING = 'MISSING';
  const parts = [
    input.device_sn !== undefined ? `device_sn: ${JSON.stringify(input.device_sn)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.starting_version !== undefined ? `starting_version: ${JSON.stringify(input.starting_version)}` : MISSING,
    input.target_version !== undefined ? `target_version: ${JSON.stringify(input.target_version)}` : MISSING,
    input.upgrading_module !== undefined ? `upgrading_module: ${JSON.stringify(input.upgrading_module)}` : MISSING,
    input.gateway_sn !== undefined ? `gateway_sn: ${JSON.stringify(input.gateway_sn)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeDeviceCommandLog = (input: DeviceCommandLog) => {
  const MISSING = 'MISSING';
  const parts = [
    input.device_sn !== undefined ? `device_sn: ${JSON.stringify(input.device_sn)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.param_name !== undefined ? `param_name: ${JSON.stringify(input.param_name)}` : MISSING,
    input.param_value !== undefined ? `param_value: ${JSON.stringify(input.param_value)}` : MISSING,
    input.gateway_sn !== undefined ? `gateway_sn: ${JSON.stringify(input.gateway_sn)}` : MISSING,
    input.string_log !== undefined ? `string_log: ${JSON.stringify(input.string_log)}` : MISSING,
    input.category !== undefined ? `category: ${JSON.stringify(input.category)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeMigrateSunflowerInput = (input: MigrateSunflowerInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.email !== undefined ? `email: ${JSON.stringify(input.email)}` : MISSING,
    input.password !== undefined ? `password: ${JSON.stringify(input.password)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAzzurroHubBody = (input: AzzurroHubBody) => {
  const MISSING = 'MISSING';
  const parts = [
    input.changeDeviceStatus !== undefined ? `changeDeviceStatus: ${serializeChangeDeviceStatusInput(input.changeDeviceStatus)}` : MISSING,
    input.changeLoggerConfig !== undefined ? `changeLoggerConfig: ${serializeChangeLoggerConfigInput(input.changeLoggerConfig)}` : MISSING,
    input.changePlantConfig !== undefined ? `changePlantConfig: ${serializeChangePlantConfigInput(input.changePlantConfig)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeChangeDeviceStatusInput = (input: ChangeDeviceStatusInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.operation !== undefined ? `operation: ${input.operation}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeChangeLoggerConfigInput = (input: ChangeLoggerConfigInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.country !== undefined ? `country: ${JSON.stringify(input.country)}` : MISSING,
    input.IANA !== undefined ? `IANA: ${JSON.stringify(input.IANA)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeChangePlantConfigInput = (input: ChangePlantConfigInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.actPwrCtrlAlgo !== undefined ? `actPwrCtrlAlgo: ${input.actPwrCtrlAlgo}` : MISSING,
    input.actPwrCtrlEna !== undefined ? `actPwrCtrlEna: ${JSON.stringify(input.actPwrCtrlEna)}` : MISSING,
    input.actPwrCtrlTarget !== undefined ? `actPwrCtrlTarget: ${JSON.stringify(input.actPwrCtrlTarget)}` : MISSING,
    input.intSensorInversion !== undefined ? `intSensorInversion: ${input.intSensorInversion}` : MISSING,
    input.maxContractualPwr !== undefined ? `maxContractualPwr: ${JSON.stringify(input.maxContractualPwr)}` : MISSING,
    input.maxPlantInvPwr !== undefined ? `maxPlantInvPwr: ${JSON.stringify(input.maxPlantInvPwr)}` : MISSING,
    input.monitoringMode !== undefined ? `monitoringMode: ${input.monitoringMode}` : MISSING,
    input.plantPhases !== undefined ? `plantPhases: ${input.plantPhases}` : MISSING,
    input.evchCtrlEna !== undefined ? `evchCtrlEna: ${JSON.stringify(input.evchCtrlEna)}` : MISSING,
    input.evchTimeModeEna !== undefined ? `evchTimeModeEna: ${JSON.stringify(input.evchTimeModeEna)}` : MISSING,
    input.evchTimeStart !== undefined ? `evchTimeStart: ${JSON.stringify(input.evchTimeStart)}` : MISSING,
    input.evchTimeStop !== undefined ? `evchTimeStop: ${JSON.stringify(input.evchTimeStop)}` : MISSING,
    input.evchBatteryProtectEna !== undefined ? `evchBatteryProtectEna: ${JSON.stringify(input.evchBatteryProtectEna)}` : MISSING,
    input.evchBatterySOCLimit !== undefined ? `evchBatterySOCLimit: ${JSON.stringify(input.evchBatterySOCLimit)}` : MISSING,
    input.evchPwrImportLimit !== undefined ? `evchPwrImportLimit: ${JSON.stringify(input.evchPwrImportLimit)}` : MISSING,
    input.evchPwrImportValue !== undefined ? `evchPwrImportValue: ${JSON.stringify(input.evchPwrImportValue)}` : MISSING,
    input.evchParallelEna !== undefined ? `evchParallelEna: ${JSON.stringify(input.evchParallelEna)}` : MISSING,
    input.evchStrategy !== undefined ? `evchStrategy: ${input.evchStrategy}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeReceiveAckRequest = (input: ReceiveAckRequest) => {
  const MISSING = 'MISSING';
  const parts = [
    input.transactionId !== undefined ? `transactionId: ${JSON.stringify(input.transactionId)}` : MISSING,
    input.version !== undefined ? `version: ${JSON.stringify(input.version)}` : MISSING,
    input.deviceId !== undefined ? `deviceId: ${JSON.stringify(input.deviceId)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.dataType !== undefined ? `dataType: ${input.dataType}` : MISSING,
    input.message !== undefined ? `message: ${JSON.stringify(input.message)}` : MISSING,
    input.success !== undefined ? `success: ${JSON.stringify(input.success)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeChangeAhHeatPumpConfigBody = (input: ChangeAhHeatPumpConfigBody) => {
  const MISSING = 'MISSING';
  const parts = [
    input.DHWOn !== undefined ? `DHWOn: ${JSON.stringify(input.DHWOn)}` : MISSING,
    input.climOnA !== undefined ? `climOnA: ${JSON.stringify(input.climOnA)}` : MISSING,
    input.DHWSetTemp !== undefined ? `DHWSetTemp: ${JSON.stringify(input.DHWSetTemp)}` : MISSING,
    input.climOpMode !== undefined ? `climOpMode: ${input.climOpMode}` : MISSING,
    input.climSetTempHeatingA !== undefined ? `climSetTempHeatingA: ${JSON.stringify(input.climSetTempHeatingA)}` : MISSING,
    input.climSetTempCoolingA !== undefined ? `climSetTempCoolingA: ${JSON.stringify(input.climSetTempCoolingA)}` : MISSING,
    input.sn !== undefined ? `sn: ${JSON.stringify(input.sn)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeModbusCommandsAttributes = (input: ModbusCommandsAttributes) => {
  const MISSING = 'MISSING';
  const parts = [
    input.commandString !== undefined ? `commandString: ${JSON.stringify(input.commandString)}` : MISSING,
    input.expectedRetByte !== undefined ? `expectedRetByte: ${JSON.stringify(input.expectedRetByte)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSendInvUpgradeByAHInput = (input: SendInvUpgradeByAHInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.fileType !== undefined ? `fileType: ${JSON.stringify(input.fileType)}` : MISSING,
    input.fileCRC !== undefined ? `fileCRC: ${JSON.stringify(input.fileCRC)}` : MISSING,
    input.fileURL !== undefined ? `fileURL: ${JSON.stringify(input.fileURL)}` : MISSING,
    input.fileSize !== undefined ? `fileSize: ${JSON.stringify(input.fileSize)}` : MISSING,
    input.CC !== undefined ? `CC: ${JSON.stringify(input.CC)}` : MISSING,
    input.CR !== undefined ? `CR: ${JSON.stringify(input.CR)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeInverterUpgradeInput = (input: InverterUpgradeInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.hub !== undefined ? `hub: ${serializeAzzurroHubUpgradeInput(input.hub)}` : MISSING,
    input.solarman !== undefined ? `solarman: ${serializeSolarmanUpgradeInput(input.solarman)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeAzzurroHubUpgradeInput = (input: AzzurroHubUpgradeInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.loggerId !== undefined ? `loggerId: ${JSON.stringify(input.loggerId)}` : MISSING,
    input.deviceSN !== undefined ? `deviceSN: ${JSON.stringify(input.deviceSN)}` : MISSING,
    input.deviceType !== undefined ? `deviceType: ${input.deviceType}` : MISSING,
    input.transactionId !== undefined ? `transactionId: ${JSON.stringify(input.transactionId)}` : MISSING,
    input.packages !== undefined ? `packages: ${input.packages.map((item) => serializeSendInvUpgradeByAHInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSolarmanUpgradeInput = (input: SolarmanUpgradeInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.iot !== undefined ? `iot: ${serializeSolarmanIotUpgradeInput(input.iot)}` : MISSING,
    input.api !== undefined ? `api: ${serializeSolarmanApiUpgradeInput(input.api)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSolarmanIotUpgradeInput = (input: SolarmanIotUpgradeInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.loggerId !== undefined ? `loggerId: ${JSON.stringify(input.loggerId)}` : MISSING,
    input.inverterId !== undefined ? `inverterId: ${JSON.stringify(input.inverterId)}` : MISSING,
    input.fileType !== undefined ? `fileType: ${JSON.stringify(input.fileType)}` : MISSING,
    input.fileCRC !== undefined ? `fileCRC: ${JSON.stringify(input.fileCRC)}` : MISSING,
    input.fileURL !== undefined ? `fileURL: ${JSON.stringify(input.fileURL)}` : MISSING,
    input.fileSize !== undefined ? `fileSize: ${JSON.stringify(input.fileSize)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSolarmanApiUpgradeInput = (input: SolarmanApiUpgradeInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.loggerId !== undefined ? `loggerId: ${JSON.stringify(input.loggerId)}` : MISSING,
    input.deviceSN !== undefined ? `deviceSN: ${JSON.stringify(input.deviceSN)}` : MISSING,
    input.timeoutSeconds !== undefined ? `timeoutSeconds: ${JSON.stringify(input.timeoutSeconds)}` : MISSING,
    input.packages !== undefined ? `packages: ${input.packages.map((item) => serializeSolarmanPackageInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeSolarmanPackageInput = (input: SolarmanPackageInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.ipUrl !== undefined ? `ipUrl: ${JSON.stringify(input.ipUrl)}` : MISSING,
    input.domainUrl !== undefined ? `domainUrl: ${JSON.stringify(input.domainUrl)}` : MISSING,
    input.name !== undefined ? `name: ${JSON.stringify(input.name)}` : MISSING,
    input.size !== undefined ? `size: ${JSON.stringify(input.size)}` : MISSING,
    input.crc !== undefined ? `crc: ${JSON.stringify(input.crc)}` : MISSING,
    input.expectedVersion !== undefined ? `expectedVersion: ${JSON.stringify(input.expectedVersion)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeReceiveModbusCommandForAHinput = (input: ReceiveModbusCommandForAHinput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.id !== undefined ? `id: ${JSON.stringify(input.id)}` : MISSING,
    input.version !== undefined ? `version: ${JSON.stringify(input.version)}` : MISSING,
    input.deviceSN !== undefined ? `deviceSN: ${JSON.stringify(input.deviceSN)}` : MISSING,
    input.gatewaySN !== undefined ? `gatewaySN: ${JSON.stringify(input.gatewaySN)}` : MISSING,
    input.deviceType !== undefined ? `deviceType: ${JSON.stringify(input.deviceType)}` : MISSING,
    input.timestamp !== undefined ? `timestamp: ${JSON.stringify(input.timestamp)}` : MISSING,
    input.dataType !== undefined ? `dataType: ${JSON.stringify(input.dataType)}` : MISSING,
    input.dataMap !== undefined ? `dataMap: ${input.dataMap?.map((item) => serializeResponseModbusCommandsAttributesInput(item)).join(",").replace(/^(.*)$/g, '[$1]')}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeResponseModbusCommandsAttributesInput = (input: ResponseModbusCommandsAttributesInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.groupID !== undefined ? `groupID: ${JSON.stringify(input.groupID)}` : MISSING,
    input.result !== undefined ? `result: ${JSON.stringify(input.result)}` : MISSING,
    input.commandResponse !== undefined ? `commandResponse: ${JSON.stringify(input.commandResponse)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeVirtualRTTelemetryInput = (input: VirtualRTTelemetryInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.deviceId !== undefined ? `deviceId: ${JSON.stringify(input.deviceId)}` : MISSING,
    input.loggerId !== undefined ? `loggerId: ${JSON.stringify(input.loggerId)}` : MISSING,
    input.target !== undefined ? `target: ${input.target}` : MISSING,
    input.ZZ !== undefined ? `ZZ: ${serializeInverterV2Input(input.ZZ)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeInverterV2Input = (input: InverterV2Input) => {
  const MISSING = 'MISSING';
  const parts = [
    input.created !== undefined ? `created: ${JSON.stringify(input.created)}` : MISSING,
    input.GwId !== undefined ? `GwId: ${JSON.stringify(input.GwId)}` : MISSING,
    input.ALERTS !== undefined ? `ALERTS: ${JSON.stringify(input.ALERTS)}` : MISSING,
    input.ALERTS_ZCS !== undefined ? `ALERTS_ZCS: ${JSON.stringify(input.ALERTS_ZCS)}` : MISSING,
    input.ARM !== undefined ? `ARM: ${JSON.stringify(input.ARM)}` : MISSING,
    input.DSPM !== undefined ? `DSPM: ${JSON.stringify(input.DSPM)}` : MISSING,
    input.DSPS !== undefined ? `DSPS: ${JSON.stringify(input.DSPS)}` : MISSING,
    input.BP !== undefined ? `BP: ${JSON.stringify(input.BP)}` : MISSING,
    input.BP1 !== undefined ? `BP1: ${JSON.stringify(input.BP1)}` : MISSING,
    input.BP2 !== undefined ? `BP2: ${JSON.stringify(input.BP2)}` : MISSING,
    input.BT !== undefined ? `BT: ${JSON.stringify(input.BT)}` : MISSING,
    input.BT1 !== undefined ? `BT1: ${JSON.stringify(input.BT1)}` : MISSING,
    input.BT2 !== undefined ? `BT2: ${JSON.stringify(input.BT2)}` : MISSING,
    input.BC !== undefined ? `BC: ${JSON.stringify(input.BC)}` : MISSING,
    input.BC1 !== undefined ? `BC1: ${JSON.stringify(input.BC1)}` : MISSING,
    input.BC2 !== undefined ? `BC2: ${JSON.stringify(input.BC2)}` : MISSING,
    input.BN1 !== undefined ? `BN1: ${JSON.stringify(input.BN1)}` : MISSING,
    input.BN2 !== undefined ? `BN2: ${JSON.stringify(input.BN2)}` : MISSING,
    input.EG1 !== undefined ? `EG1: ${JSON.stringify(input.EG1)}` : MISSING,
    input.EG2 !== undefined ? `EG2: ${JSON.stringify(input.EG2)}` : MISSING,
    input.EG3 !== undefined ? `EG3: ${JSON.stringify(input.EG3)}` : MISSING,
    input.EG4 !== undefined ? `EG4: ${JSON.stringify(input.EG4)}` : MISSING,
    input.EG5 !== undefined ? `EG5: ${JSON.stringify(input.EG5)}` : MISSING,
    input.EG6 !== undefined ? `EG6: ${JSON.stringify(input.EG6)}` : MISSING,
    input.ET1 !== undefined ? `ET1: ${JSON.stringify(input.ET1)}` : MISSING,
    input.ET2 !== undefined ? `ET2: ${JSON.stringify(input.ET2)}` : MISSING,
    input.ET3 !== undefined ? `ET3: ${JSON.stringify(input.ET3)}` : MISSING,
    input.ET4 !== undefined ? `ET4: ${JSON.stringify(input.ET4)}` : MISSING,
    input.ET5 !== undefined ? `ET5: ${JSON.stringify(input.ET5)}` : MISSING,
    input.ET6 !== undefined ? `ET6: ${JSON.stringify(input.ET6)}` : MISSING,
    input.FC1 !== undefined ? `FC1: ${JSON.stringify(input.FC1)}` : MISSING,
    input.FC2 !== undefined ? `FC2: ${JSON.stringify(input.FC2)}` : MISSING,
    input.FC3 !== undefined ? `FC3: ${JSON.stringify(input.FC3)}` : MISSING,
    input.FR !== undefined ? `FR: ${JSON.stringify(input.FR)}` : MISSING,
    input.FT1 !== undefined ? `FT1: ${JSON.stringify(input.FT1)}` : MISSING,
    input.FT2 !== undefined ? `FT2: ${JSON.stringify(input.FT2)}` : MISSING,
    input.FT3 !== undefined ? `FT3: ${JSON.stringify(input.FT3)}` : MISSING,
    input.P_1AB !== undefined ? `P_1AB: ${JSON.stringify(input.P_1AB)}` : MISSING,
    input.P_1AO !== undefined ? `P_1AO: ${JSON.stringify(input.P_1AO)}` : MISSING,
    input.P_AC_HYD !== undefined ? `P_AC_HYD: ${JSON.stringify(input.P_AC_HYD)}` : MISSING,
    input.MP1 !== undefined ? `MP1: ${JSON.stringify(input.MP1)}` : MISSING,
    input.MP2 !== undefined ? `MP2: ${JSON.stringify(input.MP2)}` : MISSING,
    input.MP3 !== undefined ? `MP3: ${JSON.stringify(input.MP3)}` : MISSING,
    input.MP4 !== undefined ? `MP4: ${JSON.stringify(input.MP4)}` : MISSING,
    input.MP5 !== undefined ? `MP5: ${JSON.stringify(input.MP5)}` : MISSING,
    input.MP6 !== undefined ? `MP6: ${JSON.stringify(input.MP6)}` : MISSING,
    input.MP7 !== undefined ? `MP7: ${JSON.stringify(input.MP7)}` : MISSING,
    input.MP8 !== undefined ? `MP8: ${JSON.stringify(input.MP8)}` : MISSING,
    input.MP9 !== undefined ? `MP9: ${JSON.stringify(input.MP9)}` : MISSING,
    input.MP10 !== undefined ? `MP10: ${JSON.stringify(input.MP10)}` : MISSING,
    input.MP11 !== undefined ? `MP11: ${JSON.stringify(input.MP11)}` : MISSING,
    input.MP12 !== undefined ? `MP12: ${JSON.stringify(input.MP12)}` : MISSING,
    input.MT1 !== undefined ? `MT1: ${JSON.stringify(input.MT1)}` : MISSING,
    input.MT2 !== undefined ? `MT2: ${JSON.stringify(input.MT2)}` : MISSING,
    input.MT3 !== undefined ? `MT3: ${JSON.stringify(input.MT3)}` : MISSING,
    input.MT4 !== undefined ? `MT4: ${JSON.stringify(input.MT4)}` : MISSING,
    input.MT5 !== undefined ? `MT5: ${JSON.stringify(input.MT5)}` : MISSING,
    input.MT6 !== undefined ? `MT6: ${JSON.stringify(input.MT6)}` : MISSING,
    input.MT7 !== undefined ? `MT7: ${JSON.stringify(input.MT7)}` : MISSING,
    input.MT8 !== undefined ? `MT8: ${JSON.stringify(input.MT8)}` : MISSING,
    input.MT9 !== undefined ? `MT9: ${JSON.stringify(input.MT9)}` : MISSING,
    input.MT10 !== undefined ? `MT10: ${JSON.stringify(input.MT10)}` : MISSING,
    input.MT11 !== undefined ? `MT11: ${JSON.stringify(input.MT11)}` : MISSING,
    input.MT12 !== undefined ? `MT12: ${JSON.stringify(input.MT12)}` : MISSING,
    input.MC1 !== undefined ? `MC1: ${JSON.stringify(input.MC1)}` : MISSING,
    input.MC2 !== undefined ? `MC2: ${JSON.stringify(input.MC2)}` : MISSING,
    input.MC3 !== undefined ? `MC3: ${JSON.stringify(input.MC3)}` : MISSING,
    input.MC4 !== undefined ? `MC4: ${JSON.stringify(input.MC4)}` : MISSING,
    input.MC5 !== undefined ? `MC5: ${JSON.stringify(input.MC5)}` : MISSING,
    input.MC6 !== undefined ? `MC6: ${JSON.stringify(input.MC6)}` : MISSING,
    input.MC7 !== undefined ? `MC7: ${JSON.stringify(input.MC7)}` : MISSING,
    input.MC8 !== undefined ? `MC8: ${JSON.stringify(input.MC8)}` : MISSING,
    input.MC9 !== undefined ? `MC9: ${JSON.stringify(input.MC9)}` : MISSING,
    input.MC10 !== undefined ? `MC10: ${JSON.stringify(input.MC10)}` : MISSING,
    input.MC11 !== undefined ? `MC11: ${JSON.stringify(input.MC11)}` : MISSING,
    input.MC12 !== undefined ? `MC12: ${JSON.stringify(input.MC12)}` : MISSING,
    input.N_MPPT !== undefined ? `N_MPPT: ${JSON.stringify(input.N_MPPT)}` : MISSING,
    input.N_MAX_MPPT !== undefined ? `N_MAX_MPPT: ${JSON.stringify(input.N_MAX_MPPT)}` : MISSING,
    input.N_MAX_STRINGS !== undefined ? `N_MAX_STRINGS: ${JSON.stringify(input.N_MAX_STRINGS)}` : MISSING,
    input.P_B1 !== undefined ? `P_B1: ${JSON.stringify(input.P_B1)}` : MISSING,
    input.P_B2 !== undefined ? `P_B2: ${JSON.stringify(input.P_B2)}` : MISSING,
    input.P_B_AGGR !== undefined ? `P_B_AGGR: ${JSON.stringify(input.P_B_AGGR)}` : MISSING,
    input.P_BATTERY_LOAD !== undefined ? `P_BATTERY_LOAD: ${JSON.stringify(input.P_BATTERY_LOAD)}` : MISSING,
    input.P_DC_TOT !== undefined ? `P_DC_TOT: ${JSON.stringify(input.P_DC_TOT)}` : MISSING,
    input.P_EXP !== undefined ? `P_EXP: ${JSON.stringify(input.P_EXP)}` : MISSING,
    input.P_EXT !== undefined ? `P_EXT: ${JSON.stringify(input.P_EXT)}` : MISSING,
    input.P_LOAD !== undefined ? `P_LOAD: ${JSON.stringify(input.P_LOAD)}` : MISSING,
    input.P_SELF !== undefined ? `P_SELF: ${JSON.stringify(input.P_SELF)}` : MISSING,
    input.PK !== undefined ? `PK: ${JSON.stringify(input.PK)}` : MISSING,
    input.SK !== undefined ? `SK: ${JSON.stringify(input.SK)}` : MISSING,
    input.SC1 !== undefined ? `SC1: ${JSON.stringify(input.SC1)}` : MISSING,
    input.SC2 !== undefined ? `SC2: ${JSON.stringify(input.SC2)}` : MISSING,
    input.SC3 !== undefined ? `SC3: ${JSON.stringify(input.SC3)}` : MISSING,
    input.SC4 !== undefined ? `SC4: ${JSON.stringify(input.SC4)}` : MISSING,
    input.SC5 !== undefined ? `SC5: ${JSON.stringify(input.SC5)}` : MISSING,
    input.SC6 !== undefined ? `SC6: ${JSON.stringify(input.SC6)}` : MISSING,
    input.SC7 !== undefined ? `SC7: ${JSON.stringify(input.SC7)}` : MISSING,
    input.SC8 !== undefined ? `SC8: ${JSON.stringify(input.SC8)}` : MISSING,
    input.SC9 !== undefined ? `SC9: ${JSON.stringify(input.SC9)}` : MISSING,
    input.SC10 !== undefined ? `SC10: ${JSON.stringify(input.SC10)}` : MISSING,
    input.SC11 !== undefined ? `SC11: ${JSON.stringify(input.SC11)}` : MISSING,
    input.SC12 !== undefined ? `SC12: ${JSON.stringify(input.SC12)}` : MISSING,
    input.SC13 !== undefined ? `SC13: ${JSON.stringify(input.SC13)}` : MISSING,
    input.SC14 !== undefined ? `SC14: ${JSON.stringify(input.SC14)}` : MISSING,
    input.SC15 !== undefined ? `SC15: ${JSON.stringify(input.SC15)}` : MISSING,
    input.SC16 !== undefined ? `SC16: ${JSON.stringify(input.SC16)}` : MISSING,
    input.SC17 !== undefined ? `SC17: ${JSON.stringify(input.SC17)}` : MISSING,
    input.SC18 !== undefined ? `SC18: ${JSON.stringify(input.SC18)}` : MISSING,
    input.SC19 !== undefined ? `SC19: ${JSON.stringify(input.SC19)}` : MISSING,
    input.SC20 !== undefined ? `SC20: ${JSON.stringify(input.SC20)}` : MISSING,
    input.SC21 !== undefined ? `SC21: ${JSON.stringify(input.SC21)}` : MISSING,
    input.SC22 !== undefined ? `SC22: ${JSON.stringify(input.SC22)}` : MISSING,
    input.SC23 !== undefined ? `SC23: ${JSON.stringify(input.SC23)}` : MISSING,
    input.SC24 !== undefined ? `SC24: ${JSON.stringify(input.SC24)}` : MISSING,
    input.ST1 !== undefined ? `ST1: ${JSON.stringify(input.ST1)}` : MISSING,
    input.ST2 !== undefined ? `ST2: ${JSON.stringify(input.ST2)}` : MISSING,
    input.ST3 !== undefined ? `ST3: ${JSON.stringify(input.ST3)}` : MISSING,
    input.ST4 !== undefined ? `ST4: ${JSON.stringify(input.ST4)}` : MISSING,
    input.ST5 !== undefined ? `ST5: ${JSON.stringify(input.ST5)}` : MISSING,
    input.ST6 !== undefined ? `ST6: ${JSON.stringify(input.ST6)}` : MISSING,
    input.ST7 !== undefined ? `ST7: ${JSON.stringify(input.ST7)}` : MISSING,
    input.ST8 !== undefined ? `ST8: ${JSON.stringify(input.ST8)}` : MISSING,
    input.ST9 !== undefined ? `ST9: ${JSON.stringify(input.ST9)}` : MISSING,
    input.ST10 !== undefined ? `ST10: ${JSON.stringify(input.ST10)}` : MISSING,
    input.ST11 !== undefined ? `ST11: ${JSON.stringify(input.ST11)}` : MISSING,
    input.ST12 !== undefined ? `ST12: ${JSON.stringify(input.ST12)}` : MISSING,
    input.TB !== undefined ? `TB: ${JSON.stringify(input.TB)}` : MISSING,
    input.TB1 !== undefined ? `TB1: ${JSON.stringify(input.TB1)}` : MISSING,
    input.TB2 !== undefined ? `TB2: ${JSON.stringify(input.TB2)}` : MISSING,
    input.TI !== undefined ? `TI: ${JSON.stringify(input.TI)}` : MISSING,
    input.TYPE !== undefined ? `TYPE: ${JSON.stringify(input.TYPE)}` : MISSING,
    input.SOL_TEMP !== undefined ? `SOL_TEMP: ${JSON.stringify(input.SOL_TEMP)}` : MISSING,
    input.SOL_IRR !== undefined ? `SOL_IRR: ${JSON.stringify(input.SOL_IRR)}` : MISSING,
    input.SOL_EG !== undefined ? `SOL_EG: ${JSON.stringify(input.SOL_EG)}` : MISSING,
    input.TS !== undefined ? `TS: ${JSON.stringify(input.TS)}` : MISSING,
    input.TZ !== undefined ? `TZ: ${JSON.stringify(input.TZ)}` : MISSING,
    input.V !== undefined ? `V: ${JSON.stringify(input.V)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializePlantMyConfigInput = (input: PlantMyConfigInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.meterInversion !== undefined ? `meterInversion: ${JSON.stringify(input.meterInversion)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializedevicesBodyRes = (input: devicesBodyRes) => {
  const MISSING = 'MISSING';
  const parts = [
    input.ack !== undefined ? `ack: ${JSON.stringify(input.ack)}` : MISSING,
    input.analysisResult !== undefined ? `analysisResult: ${JSON.stringify(input.analysisResult)}` : MISSING,
    input.content !== undefined ? `content: ${JSON.stringify(input.content)}` : MISSING,
    input.createTime !== undefined ? `createTime: ${JSON.stringify(input.createTime)}` : MISSING,
    input.deviceSN !== undefined ? `deviceSN: ${JSON.stringify(input.deviceSN)}` : MISSING,
    input.orderId !== undefined ? `orderId: ${JSON.stringify(input.orderId)}` : MISSING,
    input.success !== undefined ? `success: ${JSON.stringify(input.success)}` : MISSING,
    input.updateTime !== undefined ? `updateTime: ${JSON.stringify(input.updateTime)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeInterval = (input: Interval) => {
  const MISSING = 'MISSING';
  const parts = [
    input.from !== undefined ? `from: ${JSON.stringify(input.from)}` : MISSING,
    input.to !== undefined ? `to: ${JSON.stringify(input.to)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializePlantsUidHashMap = (input: PlantsUidHashMap) => {
  const MISSING = 'MISSING';
  const parts = [
    input.plantUid !== undefined ? `plantUid: ${JSON.stringify(input.plantUid)}` : MISSING,
    input.plantHash !== undefined ? `plantHash: ${JSON.stringify(input.plantHash)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializeUser = (input: User) => {
  const MISSING = 'MISSING';
  const parts = [
    input.email !== undefined ? `email: ${JSON.stringify(input.email)}` : MISSING,
    input.operator !== undefined ? `operator: ${JSON.stringify(input.operator)}` : MISSING,
    input.userLevel !== undefined ? `userLevel: ${JSON.stringify(input.userLevel)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

export const serializePlantConflictInput = (input: PlantConflictInput) => {
  const MISSING = 'MISSING';
  const parts = [
    input.conflictId !== undefined ? `conflictId: ${JSON.stringify(input.conflictId)}` : MISSING,
  ];

  return `{${parts.filter((e) => e !== MISSING).join(",")}}`;
}

